// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App */
.app {
  background-color: #fff; /* Weißer Hintergrund für die gesamte Webseite */
  min-height: 100vh;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.body {
  font-family: 'Plus Jakarta Sans', sans-serif;
}

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden; /* Prevent horizontal scrolling */
}

/* Generische Einstellungen für Text */
h1, h2, h3, p {
  margin: 0 0 1rem 0;
  color: black;
  font-family: 'Plus Jakarta Sans', sans-serif;
}


/* Hero Section Wrapper */
.hero-wrapper {
  background-color: rgba(230, 230, 230, 1);
  border-radius: 25px;
  padding: 3rem;
  margin: 0 auto;
  margin-top: 15px;
  width: 85%;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .hero-wrapper {
    padding: 1rem; /* Adjust this to avoid alignment issues */
    width: calc(100% - 2rem); /* Account for padding */
    margin: 0 auto; /* Center */
    margin-top: 15px;
    max-width: 85%;
  }
}
/* Blauer Section Wrapper */
.content-wrapper {
  background-color: #1b7ff6;
  border-radius: 25px;
  padding: 3rem;
  margin: 15px auto;
  width: 90%;
  max-width: 85%;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 1rem; /* Adjust this to avoid alignment issues */
    width: calc(100% - 2rem); /* Account for padding */
    margin: 0 auto; /* Center */
    margin-top: 15px;
    max-width: 85%;
  }
}

/* Form  Wrapper */
.form-wrapper {
  background-color: #f1f1f1;
  border-radius: 25px;
  padding: 20px;
  margin: 2rem auto;
  width: 90%;
  max-width: 800px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

/* Optional: Für mobile Ansicht */
@media (max-width: 768px) {
  .form-wrapper {
    background-color: #f1f1f1;
    border-radius: 25px;
    padding: 10px;
    margin: 2rem auto;
    width: 95%;
    max-width: 800px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  }
}

/* Header  Wrapper */
.header-wrapper {
  background-color: #1b7ff6;
  border-radius: 25px;
  padding: 2rem;
  margin: 2rem auto;
  width: 90%;
  max-width: 1000px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

.header-wrapper h1 {
  font-family: 'Plus Jakarta Sans', sans-serif;
  color: white;
  margin: 0 auto;
  text-align: center;
  font-weight: bold;
  font-size: 30px;
}

.header-wrapper p {
  font-family: 'Plus Jakarta Sans', sans-serif;
  color: white;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  padding-top: 20px;
}

.colorful-header p{
  font-family: 'Plus Jakarta Sans', sans-serif;
  max-width: 800px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .colorful-header {
    padding: 20px;
    margin: 50px auto;
  }

  .header-wrapper {
    margin: 0 auto;
    width: 85%;
    padding: 20px;
  }

  .header-wrapper p {
    padding-top: 0px;
  }

  .colorful-header p {
    width: 85%;
    margin: 20px auto;
    text-align: center;
  }

}

/* Initial Navbar */
.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  background-color: white;
  max-width: 1000px;
  width: 90%;
  margin: 10px auto;
  border-radius: 20px;
  border: 1px solid black;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s, padding 0.3s, box-shadow 0.3s ease;
  position: relative;
  z-index: 1000;
}


/* Sticky Navbar (Initially hidden) */
.sticky-navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background-color: white;
  width: 100vw; /* Full width */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Add subtle shadow when scrolled */
  border: none;
}

.navbar-stick {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  background-color: white;
  max-width: 1000px;
  width: 90%;
  margin: 10px auto;
  border: none;
  box-shadow: none;
  transition: background-color 0.3s, padding 0.3s, box-shadow 0.3s ease;
  position: relative;
  z-index: 1000;
}

@media (max-width: 768px) {
  .navbar {
    display: none;
  }
  .sticky-navbar {
    display: none;
  }
}


/* Navbar Container */
.navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
}

/* Logo Styling */
.navbar-logo img {
  height: 40px;
  display: block;
}

/* Navbar Links */
.navbar-links {
  list-style: none;
  display: flex;
  gap: 1.5rem;
  align-items: center;
  font-weight: bold;
  padding: 0;
}

.navbar-links a {
  text-decoration: none;
  color: black;
  transition: color 0.3s;
}

.navbar-links a:hover {
  color: #1b7ff6;
  text-decoration: underline;
}

/* Button Styling */
.navbar-btn {
  background-color: #1b7ff6;
  color: white;
  padding: 15px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.navbar-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

/* Mobile Navbar */
.mobile-navbar {
  display: none; /* Initially hidden */
  background-color: white;
  padding: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  position: relative;
  z-index: 1100; /* Ensure it appears above other content */
  border-radius: 20px;
  border: 1px solid black;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Navbar Header */
.mobile-navbar-header {
  display: flex;
  justify-content: space-between; /* Ensures logo stays left and toggle moves to the right */
  align-items: center; /* Vertical centering */
  height: 60px; /* Consistent height for the header */
  width: 100%; /* Full width */
}

.mobile-navbar-toggle {
  color: #1b7ff6; /* Icon color */
  background: none; /* Transparent background */
  border: none; /* No border */
  font-size: 2rem; /* Size of the icon */
  cursor: pointer; /* Make it clickable */
  display: flex; /* Flexbox for alignment */
  align-items: center; /* Center vertically */
  justify-content: flex-end; /* Align the icon to the right */
  height: 100%; /* Match parent's height for alignment */
  width: auto; /* Adjust width to fit the content */
  margin-left: auto; /* Push the toggle to the far right */
  padding: 0; /* Remove extra padding for precise alignment */
}

.mobile-navbar-toggle svg {
  display: block; /* Ensure it behaves as a block element */
  margin: 0; /* Remove any default margins */
  width: 2rem; /* Set an appropriate size for the SVG */
  height: 2rem; /* Set an appropriate size for the SVG */
}

/* Mobile Navbar Overlay */
.mobile-navbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column; /* Stack links vertically */
  align-items: center;
  justify-content: center; /* Center the content */
  z-index: 1200; /* Ensure it overlays all other elements */
  padding: 2rem;
  box-sizing: border-box; /* Include padding and borders in width/height */
}

/* Navbar Links */
.mobile-navbar-links {
  list-style: none;
  display: flex;
  flex-direction: column; /* Stack links vertically */
  gap: 1rem; /* Add spacing between links */
  align-items: center;
  padding: 0;
}

.mobile-navbar-links a {
  text-decoration: none; /* Remove underline */
  color: black; /* Link color */
  font-size: 1.5rem; /* Font size */
  font-weight: bold; /* Bold text */
}

/* Call-to-action Button */
.mobile-navbar-btn {
  background-color: #1b7ff6;
  color: white;
  padding: 15px 30px; /* Size of the button */
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold; /* Bold text */
  font-size: 1rem; /* Font size */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth hover effect */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  margin-top: 2rem;
}

.mobile-navbar-btn:hover {
  transform: scale(1.1); /* Slightly enlarge on hover */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* Stronger shadow on hover */
}

/* Close Icon */
.mobile-navbar-close {
  color: #1b7ff6;
  position: absolute; /* Position relative to the overlay */
  top: 40px; /* Offset from the top */
  right: 20px; /* Offset from the right */
  background: none; /* Transparent background */
  border: none; /* No border */
  font-size: 2rem; /* Size of the icon */
  cursor: pointer; /* Make it clickable */
}

/* Responsive Rules */
@media (max-width: 768px) {
  .navbar-wrapper,
  .sticky-navbar {
    display: none;
  }

  .mobile-navbar {
    display: block;
  }
}

/* Hero Section */
.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  margin: 0 auto;
  max-width: 950px;
  width: 100%;
}

.hero-content {
  position: relative;
  height: auto;
  text-align: left;
  padding: 20px;
  max-width: 50%;
}

.hero-content h1 {
  font-size: 40px;
  font-weight: bolder;
}

.hero-img {
  max-width: 50%;
}

.underline {
  text-decoration: underline;
  text-decoration-color: #1b7ff6;
  text-decoration-thickness: 3px;
  color: black;
}

/* Vertical Carousel */
.v-carousel-mask {
  height: 50px; /* Match this height to itemHeight in JS */
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
}

.carousel-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.carousel-item {
  height: 50px; /* Match this height to itemHeight in JS */
  line-height: 50px; /* Vertically center text */
  font-size: 24px;
  text-align: left;
}

.hero-content span {
  height: 50px; /* Match this height to itemHeight in JS */
  line-height: 50px; /* Vertically center text */
  font-size: 24px;
  text-align: left;
}

/* Hide hero image on screens smaller than 768px */
@media (max-width: 768px) {
  .hero {
    display: flex;
    flex-direction: column; /* Stack content vertically */
    justify-content: center; /* Center items vertically */
    align-items: center; /* Center items horizontally */
    padding: 0;
    margin: 0 auto;
    width: 100%; /* Full width for the container */
    overflow: hidden; /* Prevent content overflow */
  }

  .hero-content {
    max-width: 100%;
    text-align: left; /* Center-align the text */
  }

  .hero-img {
    width: auto; /* Allow free width adjustment */
    max-width: 100%; /* Prevent image from overflowing its container */
    height: auto; /* Maintain aspect ratio */
    display: block; /* Ensure the image behaves properly in the layout */
    margin: 0; /* Remove any default margins */
    align-self: center; /* Ensure alignment within the flexbox container */
  }

  .hero-img img {
    width: 70%;
    display: block;
    margin: 0 auto;
    align-self: center;
  }

  .hero-content h1 {
    font-size: 28px; /* Adjust font-size for smaller screens */
  }

  .carousel-item {
    height: 50px; /* Match this height to itemHeight in JS */
    line-height: 50px; /* Vertically center text */
    font-size: 20px;
    text-align: left;
  }
  
  .hero-content span {
    height: 50px; /* Match this height to itemHeight in JS */
    line-height: 50px; /* Vertically center text */
    font-size: 20px;
    text-align: left;
  }
}


/* Management Hero */
.management-hero {
  display: flex; /* Flexbox Layout */
  flex-direction: column; /* Stapelt die Elemente übereinander */
  justify-content: flex-start; /* Inhalte oben starten lassen */
  align-items: center; /* Zentriert die Inhalte horizontal */
  padding: 2rem;
  margin: 40px auto;
  margin-bottom: 0px;
  max-width: 1000px; /* Maximale Breite der Hero-Section */
  width: 100%;
  height: auto; /* Füllt die volle Höhe des Viewports */
  font-family: 'Plus Jakarta Sans', sans-serif;
  text-align: center; /* Zentriert den Text */
}

.management-hero-content {
  margin-bottom: 2rem; /* Abstand zwischen Text und Bild */
  max-width: 90%;
}

.management-hero h1 {
  font-size: 40px;
}

.management-hero p {
  font-size: 18px;
  max-width: 70%;
  margin: 0 auto;
}

.hero-gif img {
  min-height: 150px;
  max-height: 350px;
  width: 100%;
  margin-bottom: 0;
}


/* Lead Form */
.lead-form {
  padding: 1rem;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: center; /* Zentriere den Inhalt horizontal */
  flex-wrap: wrap; /* Umbrüche bei kleineren Bildschirmen */
  gap: 1rem; /* Abstand zwischen den Input-Feldern */
}

.lead-form .form-row {
  display: flex; /* Flexbox für die horizontale Anordnung */
  flex-wrap: wrap; /* Umbrüche bei kleineren Bildschirmen */
  gap: 0.5rem; /* Abstand zwischen den Feldern */
}

.lead-form input,
.lead-form select {
  flex: 1 1; /* Füllt den verfügbaren Platz */
  min-width: 120px; /* Minimale Breite der Eingabefelder */
  max-width: 200px; /* Maximale Breite der Eingabefelder */
  padding: 1rem; /* Erhöhtes Padding für bessere Sichtbarkeit */
  font-size: 14px; /* Größere Schriftgröße für bessere Lesbarkeit */
  border: 1px solid black; /* Standardrahmen für Inputs */
  border-radius: 10px; /* Abgerundete Ecken für Inputs */
  text-align: center; /* Zentriert den Text im Input-Feld */
}

.lead-form input::placeholder,
.lead-form select {
  text-align: center; /* Zentriert den Platzhaltertext */
}

.lead-form button {
  background-color: #007BFF;
  color: white;
  padding: 1rem; /* Erhöhtes Padding für den Button */
  border: none;
  cursor: pointer;
  border-radius: 10px; /* Abgerundete Ecken für den Button */
  flex: 1 1; /* Gleiche Breite wie die Input-Felder */
  min-width: 120px; /* Minimale Breite für den Button */
  max-width: 200px; /* Maximale Breite für den Button */
  font-size: 14px; /* Größere Schriftgröße für den Button */
  text-align: center; /* Zentriert den Text im Button */
  font-weight: bold;
  transition: transform 0.3s ease;
}

.lead-form button:hover {
  transform: scale(1.1);
  animation: pulse 1s infinite; /* A continuous pulse on hover */
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.lead-form small {
  margin: 0 auto;
  text-align: center;
  max-width: 650px;
}

@media (max-width: 768px) {
  .lead-form button {
    align-self: center;
  }

}

/* FAQ */
.faq {
  padding: 20px;
  background-color: none;
}

.faq-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

.question-faq {
  border: 1px solid #1b7ff6;
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 10px;
  padding-bottom: 10px;
  background-color: white;

}

.faq-arrow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.arrow-faq-right {
  display: inline-block; /* sorgt dafür, dass die Transformation funktioniert */
  margin-left: 10px; /* Abstand zwischen Frage und Pfeil */
}

.faq-heading {
  font-size: 40px;
  margin-bottom: 20px;
  color: white;
}

.faq-question-heading {
  font-size: 20px;
  margin: 0;
  flex-grow: 1; /* Füge diese Zeile hinzu */
  margin-right: 10px; /* Optional: Abstand zwischen Frage und Pfeil */
}

.faq-city-title p {
  color: white;
}

.faq-wrapper-text {
  margin-top: 10px; /* Abstand oben zur Antwort */
  padding-left: 0px; /* Abstand links zur Antwort */
  overflow: hidden; /* Verhindert, dass der Inhalt sichtbar ist, während er animiert */
  background-color: white;
}

/* Antwortbereich */
.faq-answer {
  padding: 0px;
  background-color: #fff;
}

@media (max-width: 768px) {
  .faq-heading {
    font-size: 28px;
    margin-bottom: 20px;
    color: white;
  }
  .faq-city-title p {
    font-size: 15px;
  }
  .faq-question-heading {
    font-size: 15px;
  }
  .faq-answer {
    font-size: 14px;
  }
  .how-it-works-image {
    min-width: 250px;
  }
}


/* Footer Styling */
.footer {
  background-color: none; /* Weißer Hintergrund */
  color: black; /* Schwarzer Text */
  padding: 2rem; /* Innenabstand */
  font-family: 'Plus Jakarta Sans', sans-serif; /* Schriftart */
  max-width: 1000px; /* Maximale Breite */
  margin: 0 auto; /* Zentriert den Footer */
}

@media (max-width: 768px) {
  .footer {
    display: none;
  }
}

.footer-container {
  display: flex; /* Flexbox für Layout */
  justify-content: space-between; /* Platz zwischen Sektoren */
  align-items: flex-start; /* Sektoren oben ausrichten */
}

.footer-logo img {
  height: 60px; /* Logo-Höhe */
}

.footer-links {
  display: flex; /* Flexbox für Links */
  gap: 2rem; /* Abstand zwischen den Spalten */
}

.footer-column {
  display: flex; /* Flexbox für Spalten */
  flex-direction: column; /* Spalten vertikal anordnen */
}

.footer-column h4 {
  margin-bottom: 0.5rem; /* Abstand unter den Überschriften */
}

.footer-column ul {
  list-style: none; /* Keine Aufzählungszeichen */
  padding: 0; /* Kein Padding */
}

.footer-column li {
  margin-bottom: 0.5rem; /* Abstand zwischen den Links */
}

.footer-column a {
  text-decoration: none; /* Keine Unterstreichung */
  color: black; /* Schwarze Links */
  transition: color 0.3s; /* Sanfter Farbwechsel */
}

.footer-column a:hover {
  color: #1b7ff6; /* Farbwechsel beim Hover */
}

.footer-support {
  width: 100%; /* Volle Breite für den Unterstützungsteil */
  margin-top: 2rem; /* Abstand über dem Unterstützungsteil */
  display: flex; /* Flexbox für Spalten */
  flex-wrap: wrap; /* Wrap, um auf kleinere Bildschirme zu reagieren */
}

.footer-cities {
  display: flex; /* Flexbox für Städte */
  width: 100%; /* Volle Breite für die Städte */
  justify-content: space-between; /* Platz zwischen den Städten gleichmäßig verteilen */
  margin-top: 1rem; /* Abstand über dem Text */
}

.footer-city {
  flex: 1 1; /* Flex-Elemente gleichmäßig verteilen */
  text-align: center; /* Zentriere den Text */
  margin: 0 1rem; /* Abstand zwischen den Spalten */
}

.footer-divider {
  margin: 2rem 0; /* Abstand über und unter dem Strich */
  border: 0; /* Entferne den Standardrahmen */
  height: 1px; /* Höhe des Strichs */
  background-color: #ccc; /* Farbe des Strichs */
}

.footer-info {
  text-align: center; /* Text zentrieren */
  margin-top: 1rem; /* Abstandh oben */
}

.footer-info a {
  text-decoration: none;
  color: black;
}

@media (max-width: 768px) {
  .footer-logo img {
    height: 40px; /* Logo-Höhe */
  }
}

/* Mobile Footer */
/* Mobile Footer */
.mobile-footer {
  display: none; /* Hidden by default */
  background-color: none;
  color: black;
  padding: 1rem;
  font-family: 'Plus Jakarta Sans', sans-serif;
  margin-top: 50px;
}

@media (max-width: 768px) {
  .mobile-footer {
    display: block; /* Only visible on mobile */
    padding: 30px;
    padding-top: 0px;
  }
}

.mobile-footer-logo {
  text-align: left; /* Align the logo to the top-left */
  margin-bottom: 1rem;
}

.mobile-footer-logo img {
  height: 50px;
}

.mobile-footer-links {
  display: flex;
  flex-direction: column;
  gap: 1rem; /* Space between sections */
}

.mobile-footer-column h4 {
  font-size: 1rem;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 0.5rem;
}

.mobile-footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-footer-column li {
  margin-bottom: 0.5rem;
}

.mobile-footer-column a {
  text-decoration: none;
  color: black;
  font-size: 0.9rem;
}

.mobile-footer-column a:hover {
  color: #1b7ff6;
}

.mobile-footer-info {
  margin-top: 1rem;
  text-align: left;
  font-size: 0.8rem;
  color: #666;
}

.mobile-footer-info a {
  color: black;
  text-decoration: none;
}

.mobile-footer-info a:hover {
  color: #1b7ff6;
}

/* ThreeColumns Styling */

.three-columns {
  padding: 2rem;
  background-color: none; /* Heller Hintergrund */
  text-align: center;
  max-width: 1000px;
  margin:0 auto;
  margin-top: 100px;
}

.three-columns-title {
  margin-bottom: 1.5rem; /* Abstand unter der Überschrift */
  font-family: 'Plus Jakarta Sans', sans-serif;
  text-align: center;
}

.three-columns-small-title {
  color: #666;
  text-align: center;
}

.three-columns-small-title a {
  color: #1b7ff6;
}

.three-columns-container {
  display: flex; /* Flexbox for the columns */
  justify-content: space-between; /* Space between columns */
  gap: 1rem;
}

/* Make the columns stack vertically on screens smaller than 768px */
@media (max-width: 768px) {
  .three-columns-container {
    flex-direction: column; /* Stack columns vertically */
    align-items: center;
  }

  .three-columns {
    margin-top: 50px;
  }
  
  .three-columns-title {
    font-size: 28px;
  }
}

.three-column-image {
  max-width: 100%; /* Bild responsive */
  height: auto;
}

.three-column-subtitle {
  padding: 10px 20px;
  border: 1px solid #1b7ff6;
  border-radius: 10px;
  background-color: #1b7ff6;
  color: white;
}

.three-column-text {
  margin-top: 0.5rem; /* Abstand über dem Text */
}

/* ThreeStep Styling */
.three-step {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  margin-top: 80px;
}

.three-step h1 {
  text-align: center;
}

.three-step-small {
  color: #666;
  text-align: center;
}

.three-step-small a {
  color: #1b7ff6;
}

.step {
  display: flex; /* Flex layout for desktop */
  align-items: center;
  margin-bottom: 20px;
}

.step-circle {
  background-color: #1b7ff6;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-right: 1rem;
}

.step-content {
  flex: 1 1;
}

.step-title {
  margin-bottom: 0.5rem;
}

.step-image {
  max-width: 100%;
  height: auto;
}

/* Mobile styling */
@media (max-width: 768px) {
  .three-step {
    margin-top: 50px;
  }
  .three-step h1 {
    font-size: 28px;
  }
  .step {
    display: flex;
    align-items: center;
    flex-direction: row; /* Align circle and content horizontally */
    justify-content: flex-start;
  }

  .step-circle {
    display: none;
  }

  .step-content {
    text-align: center; /* Align text to the left on mobile */
    border: 1px solid grey;
    border-radius: 15px;
  }

  .step img {
    display: none; /* Hide images mobile */
  }
}

/* White Button */
.button-white-container {
  display: flex;
  justify-content: center; /* Zentriert den Button horizontal */
  margin: 2rem 0; /* Abstand oben und unten */
}

.custom-white-button {
  background-color: #f1f1f1;
  color: black;
  padding: 20px; /* Erhöhtes Padding für den Button */
  border: none;
  cursor: pointer;
  border-radius: 10px; /* Abgerundete Ecken für den Button */
  min-width: 120px; /* Minimale Breite für den Button */
  max-width: 300px; /* Maximale Breite für den Button */
  font-size: 16px; /* Größere Schriftgröße für den Button */
  text-align: center; /* Zentriert den Text im Button */
  font-weight: bold;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Normal shadow */
}

.custom-white-button:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* Shadow becomes more intense */
}


/* Blue Button */
.button-blue-container {
  display: flex;
  justify-content: center; /* Zentriert den Button horizontal */
  margin: 0; /* Abstand oben und unten */
}

.custom-blue-button {
  background-color: #1b7ff6;
  color: white;
  padding: 20px; /* Erhöhtes Padding für den Button */
  border: none;
  cursor: pointer;
  border-radius: 10px; /* Abgerundete Ecken für den Button */
  min-width: 120px; /* Minimale Breite für den Button */
  max-width: 300px; /* Maximale Breite für den Button */
  font-size: 16px; /* Größere Schriftgröße für den Button */
  text-align: center; /* Zentriert den Text im Button */
  font-weight: bold;
  margin-bottom: 40px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Normal shadow */
}

.custom-blue-button:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* Shadow becomes more intense */
}


/* Gesamtformular-Wrapper */
.form {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 500px; /* Definiere eine Mindesthöhe für das gesamte Formular */
  height: 100%; /* Damit sich das Formular dynamisch an die Höhe anpasst */
}

/* Fortschrittsanzeige (Progress Bar) */
.progress-bar-wrapper {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 10px;
  margin-bottom: 20px;
  position: relative;
}

.progress-bar {
  height: 30px;
  background-color: #1b7ff6;
  border-radius: 10px;
  text-align: center;
  color: white;
  font-weight: bold;
  transition: width 0.3s ease;
}


/* Container für den dynamischen Inhalt (Schritte) */
.form-container {
  background-color: none;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Inhalt oben ausrichten */
  min-height: 300px;
  max-height: 300px; /* Setze eine Maximalhöhe, um eine konstante Höhe zu gewährleisten */
  box-sizing: border-box; /* Verhindert, dass Padding die Höhe beeinflusst */
}

/* Zentriert die Überschrift im Formular */
.form h2 {
  text-align: center;
  margin-bottom: 30px;
}

/* Überschrift der einzelnen Schritte oben ausrichten */
.form-container h3 {
  margin-top: 0; /* Keine zusätzliche Oberkante */
  margin-bottom: 20px; /* Konsistenter Abstand nach unten */
  font-family: 'Plus Jakarta Sans', sans-serif;
}

/* Button-Container mit einem Button (unten rechts) */
.hv-button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 0px;
}

/* Spezielle Klasse für den Button-Container im ersten Schritt */
.single-button-container {
  justify-content: flex-end;
}

/* Wenn zwei Buttons da sind (Zurück und Weiter) */
.hv-two-button-container {
  justify-content: space-between;
}

.hv-next-button,
.hv-back-button {
  padding: 12px; /* Feste Höhe durch gleichmäßiges Padding */
  min-height: 40px; /* Mindesthöhe für alle Buttons */
  min-width: 100px;
  font-size: 14px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}

.hv-radio-container,
.hv-radio,
.hv-input-container,
.hv-input {
  box-sizing: border-box;
}

.hv-input-container {
  gap: 10px;
}

/* Remove spinner controls from number input */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield; /* For Firefox */
}

/* Style für den "Weiter"-Button */
.hv-next-button {
  background-color: #1b7ff6;
  color: white;
  padding: 10px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  min-width: 100px;
  height: auto;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}

/* Style für den "Zurück"-Button */
.hv-back-button {
  background-color: transparent;
  color: #1b7ff6;
  border: 2px solid #1b7ff6;
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  min-width: 100px;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}

/* Datenschutz-Text */
small {
  margin-top: 20px;
  display: block;
  text-align: center;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

small a {
  color: #1b7ff6;
  text-decoration: none;
}

.hv-radio-container {
  display: flex;                   
  flex-direction: column;          
  width: 100%;      
  align-items: center;          
}

.hv-radio {
  display: flex;                   
  align-items: center;             
  margin-bottom: 10px;            
  width: 100%;                    
  padding: 12px;                  
  border: 1px solid #1b7ff6;     
  border-radius: 10px;            
  background-color: transparent;     
  font-size: 14px;                
  cursor: pointer;                
  transition: background-color 0.3s; 
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.hv-radio:hover {
  background-color: #1b7ff6;      /* Hintergrundfarbe beim Hover */
  color: white;
  font-size: bold;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.hv-radio input {
  margin-right: 10px;             /* Abstand zwischen Radio-Button und Label-Text */
}

/* Styling the checked radio input + adjacent .hv-radio */
.hv-radio.checked {
  background-color: #1b7ff6;
  color: white;
}

/* Modernes Styling für das Dropdown-Menü */
.hv-select-wrapper {
  position: relative;
  width: 100%;
  display: flex;
}

.hv-select-wrapper::after {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.hv-select {
  flex: 1 1; /* Füllt den verfügbaren Platz im Wrapper */
  padding: 12px;
  font-size: 14px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  border-radius: 10px;
  background-color: transparent;
  color: black;
  border: 1px solid #1b7ff6;
  appearance: none; /* Entfernt den Standard-Stil */
  cursor: pointer;
  transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out; /* Smooth ease-out animation */        
}


/* Styling für die Input-Felder (Schritt 3 und 5) */
.hv-input-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Zentriert die Inhalte horizontal */
}

.hv-input {
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  border-radius: 10px;
  background-color: transparent;
  color: black;
  border: 1px solid #1b7ff6;
  appearance: none; /* Entfernt den Standard-Stil */
  cursor: pointer;
  transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out; /* Smooth ease-out animation */
  align-items: center;    
}

.hv-input:focus {
  border-color: #0056b3; /* Dunklerer Blauton beim Fokussieren */
  outline: none;
}

.hv-input::placeholder {
  color: #aaa; /* Graue Platzhalterfarbe */
  font-style: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
}


/* Form Schritt 6 */
.hv-input-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 Spalten */
  gap: 10px; /* Abstand zwischen den Feldern */
}

.hv-input-group {
  display: flex;
  flex-direction: column;
}

.hv-input-multi {
  width: auto;
  padding: 12px;
  font-size: 14px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  border-radius: 10px;
  background-color: transparent;
  color: black;
  border: 1px solid #1b7ff6;
  appearance: none; /* Entfernt den Standard-Stil */
  cursor: pointer;
  transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out; /* Smooth ease-out animation */
  align-items: center;    
}

.hv-input-multi::placeholder {
  color: #aaa; /* Graue Platzhalterfarbe */
  font-family: 'Plus Jakarta Sans', sans-serif;
}

@media (max-width: 768px) {
  .hv-input-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%; /* Ensure the container doesn't overflow */
    box-sizing: border-box; /* Includes padding and borders in the width */
  }

  .hv-input-group {
    width: 100%; /* Ensure each group takes full width */
    box-sizing: border-box; /* Prevent overflow due to padding */
  }

  .hv-input-multi {
    width: 100%; /* Prevent inputs from overflowing */
    max-width: 100%; /* Ensure inputs stay within their parent */
    box-sizing: border-box; /* Include padding and borders in the width calculation */
  }

  /* Optional: Add padding to prevent content from touching screen edges */
  .form-container {
    padding: 0 16px; /* Add left/right padding for better mobile UX */
  }
}

/* Form Header */

.form-header {
  display: flex;
  justify-content: center; 
  align-items: center; 
  height: auto; 
  background-color: none;
  text-align: center; 
  padding: 0px;
  margin-top: 0px;
}

.header-content {
  max-width: 450px;
}

.header-content small {
  font-size: 14px; 
  font-family: 'Plus Jakarta Sans', sans-serif;
  color: white; 
  display: block;
  margin-bottom: 10px;
}

.header-content h1 {
  font-size: 32px; 
  font-family: 'Plus Jakarta Sans', sans-serif;
  color: white; 
  margin-bottom: 15px;
}

.header-content p {
  font-size: 18px; /* Mittlere Schriftgröße für den Beschreibungstext */
  font-family: 'Plus Jakarta Sans', sans-serif;
  color: white; /* Leicht abgedunkelte Farbe */
  margin-bottom: -5px;
}

@media (max-width: 768px) {
  .header-content h1 {
    font-size: 28px; 
    font-family: 'Plus Jakarta Sans', sans-serif;
    color: white; 
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .header-content p {
    font-size: 16px; /* Mittlere Schriftgröße für den Beschreibungstext */
    font-family: 'Plus Jakarta Sans', sans-serif;
    color: white; /* Leicht abgedunkelte Farbe */
    margin-bottom: -5px;
  }

}

/* Impressum */
.impressum-container {
  max-width: 1000px;
  width: 90%;
  margin: 40px auto;
}

@media (max-width: 768px) {
  .impressum-container h1 {
    font-size: 28px;
  }
}



/* Blog Styling*/
.blog-overview {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px;
  margin: 0 auto;
  max-width: 1200px;
  justify-content: center;
  align-items: stretch; /* Ensures all cards have the same height */
  margin-top: 60px;
}

.blog-card {
  width: 30%;
  max-width: 350px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 100%; /* Ensures the card takes up full height */
  min-height: 380px;
}

.blog-card a {
  display: flex;
  flex-direction: column;
  flex-grow: 1; /* Ensures the link content grows */
  text-decoration: none;
  color: inherit;
}

.blog-card h2 {
  font-size: 22px;
}

.blog-card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.blog-card-content {
  padding: 15px;
  flex-grow: 1; /* Make the content take up remaining space */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.blog-meta {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Vertikales Zentrieren */
  font-size: 0.9rem;
  color: #666;
  margin-top: auto; /* Damit das gesamte meta unten ist */
}

.blog-date {
  display: flex;
  align-items: center; /* Stellt sicher, dass der Inhalt auch im Span vertikal zentriert ist */
}

/* Category styles */
.blog-category {
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  display: inline-block;
}

.blog-category.category-news {
  background-color: #ff6b6b; /* Red for news */
}

.blog-category.category-vermietung {
  background-color: #4ecdc4; /* Turquoise for vermietung */
}

.blog-category.category-verwaltung {
  background-color: #1a73e8; /* Blue for verwaltung */
}

.load-more-btn {
  background-color: #1b7ff6;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px auto;
  display: block;
}

.load-more-btn:hover {
  background-color: #1b7ff6;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.blog-wrapper {
  position: relative;
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.category-filter {
  position: absolute;
  display: flex;
  gap: 5px;
  padding: 5px;
}

/* Common button styling */
.category-btn {
  background-color: #f0f0f0;
  color: black;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease, color 0.3s ease;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

/* Active button styling */
.category-btn.active {
  background-color: #1b7ff6;
  color: white;
}

/* Hover effect */
.category-btn:hover {
  background-color: #1b7ff6;
  color: white;
}

/* Custom styling for each category */
.category-btn-news:hover,
.category-btn-news.active {
  background-color: #ff6b6b; /* Red for news */
  color: white;
}
.category-btn-vermietung:hover,
.category-btn-vermietung.active {
  background-color: #4ecdc4; /* Turquoise for vermietung */
  color: white;
}

.category-btn-verwaltung:hover,
.category-btn-verwaltung.active {
  background-color: #1a73e8; /* Blue for verwaltung */
  color: white;
}

/* Ensure active buttons retain their color when selected */
.category-btn-news.active,
.category-btn-vermietung.active,
.category-btn-verwaltung.active {
  color: white;
}
/* Author styling */
.blog-author {
  display: flex;
  align-items: center;
  padding: 20px;
}

.author-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
}

.blog-detail {
  padding: 40px;
  max-width: 1000px;
  margin: 0 auto;
}

.blog-main-image {
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 10px;
}

.blog-content {
  padding: 20px;
}

.blog-body {
  font-size: 1.1rem;
  line-height: 1.6;
}

.blog-body img {
  display: block;
  margin: 0 auto; /* Centers the image horizontally */
  max-width: 100%; /* Makes the image responsive */
  height: auto; /* Maintains aspect ratio */
}


@media (max-width: 768px) {
  .blog-wrapper {
    padding: 0px;
    margin-top: 0px;
  }
  
  .category-filter {
    margin-top: 0px;
    display: none;
  }

  .blog-overview {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 5px;
    margin: 0 auto;
    max-width: 1200px;
    justify-content: center;
    align-items: stretch; /* Ensures all cards have the same height */
    margin-top: 50px;
  }
  
  .blog-card {
    width: 80%;
    max-width: 350px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    height: 100%; /* Ensures the card takes up full height */
    min-height: 100%;
  }

  .blog-card a {
    display: flex;
    flex-direction: column;
    flex-grow: 1; /* Ensures the link content grows */
    text-decoration: none;
    color: inherit;
  }
  
  .blog-card h2 {
    font-size: 20px;
    text-align: center;
  }
  
  .blog-card-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
  }
  
  .blog-card-content {
    padding: 15px;
    flex-grow: unset; /* Remove the flex-grow behavior */
    display: block; /* Remove column flex behavior */
  }
  
  .blog-meta {
    gap: 5px; /* Add a small gap between category and date */
    justify-content: space-between; /* Center the content */
    margin-top: 0; /* Remove extra margin */
    }
  
  .blog-date {
    display: flex;
    align-items: center; /* Stellt sicher, dass der Inhalt auch im Span vertikal zentriert ist */
  }
  
  .blog-detail {
    padding: 10px;
  }

  .blog-body {
    font-size: 16px;
  }
}


/* Mission Section */
.mission {
  display: flex; /* Flexbox Layout für die horizontale Anordnung von Text und Bild */
  justify-content: space-between; /* Text und Bild werden aufgeteilt */
  align-items: center; /* Vertikale Zentrierung */
  padding: 40px; /* Padding für die gesamte Sektion */
  margin: 0 auto;
  max-width: 850px; /* Maximale Breite der Sektion */
  width: 100%; /* Volle Breite */
  margin-top: 60px;
}

.mission-content {
  max-width: 66%; /* Maximalbreite für den Textbereich */
}

.mission-small-text {
  font-size: 14px; /* Kleinere Schrift für den Mission-Text */
  color: #1b7ff6; /* Optional: Farbe für den kleinen Text */
  text-transform: uppercase; /* Optional: Alles groß schreiben */
  margin-bottom: 0.5rem;
}

.mission-heading {
  font-size: 30px; /* Große Schrift für H1 */
  font-weight: bold;
  margin-bottom: 1rem;
}

.mission-content a{
  color: #1b7ff6;
}

.mission-content h3 {
  color: #666;
}

.mission-paragraph {
  font-size: 18px; /* Normaler Schriftgröße für den Paragraphen */
  line-height: 1.6; /* Zeilenhöhe für bessere Lesbarkeit */
}

.mission-image img {
  max-width: 100%; /* Bild passt sich der Breite des Containers an */
  height: auto; /* Proportionales Skalieren des Bildes */
  margin-left: 2rem; /* Abstand zwischen Text und Bild */
  border-radius: 8px; /* Optional: abgerundete Ecken beim Bild */
}

/* Mobile Styling */
/* Mission Section - Mobile Fix */
@media (max-width: 768px) {
  .mission {
    display: flex;
    flex-direction: column; /* Stack content vertically */
    align-items: center; /* Center-align all content horizontally */
    justify-content: center; /* Center-align vertically */
    padding: 20px; /* Adjust padding */
    margin: 0 auto; /* Center the section */
    margin-top: 50px;
    width: 100%; /* Ensure full width */
    max-width: 100%; /* Prevent overflow */
    box-sizing: border-box; /* Include padding and border in width */
    text-align: center; /* Center-align text */
    overflow-x: hidden; /* Prevent horizontal scrolling */
  }

  .mission-content {
    max-width: 90%; /* Limit the width of text content */
    margin: 0 auto; /* Center-align the text block */
  }

  .mission-heading {
    font-size: 28px; /* Adjust font size for headings */
    margin-bottom: 10px; /* Add space below the heading */
  }

  .mission-content h3 {
    font-size: 18px;
  }

  .mission-paragraph {
    font-size: 16px; /* Adjust font size for readability */
    line-height: 1.6; /* Improve line spacing */
    margin-bottom: 20px; /* Add space below the paragraph */
  }

  .mission-image img {
    width: 70%; /* Restrict image width */
    max-width: 300px; /* Prevent images from being too large */
    height: auto; /* Maintain aspect ratio */
    margin: 0 auto; /* Center the image */
    display: block; /* Ensure proper image rendering */
  }
}

/* Change Section */
.change-section {
  padding: 3rem 2rem; /* Padding um die gesamte Sektion */
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.change-header {
  text-align: center; /* Zentriert den Header */
  margin-bottom: 3rem; /* Abstand zwischen Header und den Schritten */
}

.change-small-text {
  color: #666;
  margin-bottom: 0.5rem;
}

.change-small-text a {
  color: #1b7ff6;
}

.change-heading {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 1rem;
}

.change-paragraph {
  font-size: 18px;
  line-height: 1.6;
  color: #555; /* Optional: Etwas hellere Textfarbe für bessere Lesbarkeit */
  max-width: 600px;
  margin: 0 auto;
  margin-top: 20px;
}

/* Change Steps */
.change-steps {
  display: flex;
  flex-direction: column;
  gap: 2rem; /* Abstand zwischen den Schritten */
  max-width: 800px;
  margin: 0 auto;
}

.change-step {
  display: flex;
  align-items: center;
  gap: 2rem; /* Abstand zwischen Bild und Text */
  margin-right: 0;
}

.change-step img {
  width: 80px; /* Festgelegte Breite des Bildes */
  height: auto;
  align-self: left;
}

.change-step-content {
  max-width: auto; /* Maximale Breite für den Textbereich des Schritts */
}

.step-small-text {
  font-size: 14px;
  color: #1b7ff6;
  margin-bottom: 0.5rem;
}

.step-paragraph {
  font-size: 18px;
  line-height: 1.6;
  color: #555;
  margin-bottom: 0px;
}

.step-paragraph a {
  color: #1b7ff6;
}

/* Optional: Für mobile Ansicht */
@media (max-width: 768px) {
  .change-section {
    padding: 15px;
    margin-bottom: 50px;
  }

  .change-heading {
    font-size: 28px;
  }

  .change-small-text {
   font-size: 18px;
  }

  .step-paragraph {
    font-size: 14px;
  }

  .change-step img {
    width: 20%;
    max-width: 300px; /* Maximale Breite für Bilder in der mobilen Ansicht */
  }
  .change-step-content {
    max-width: 100%;
  }
}



/* Container für die Vorteile */
.advantages-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 20px;
  background-color: none; /* Optionaler Hintergrund */
  border-radius: 10px; /* Abgerundete Ecken für das Container */
  max-width: 80%;
  margin: 0 auto;
}

/* Einzelnes Vorteil-Element */
.advantage-item {
  display: flex;
  align-items: center;
  background-color: #f1f1f1;
  padding: 20px;
  border-radius: 10px;
  width: 32%; /* Nimmt 32% der Breite für drei gleich große Boxen nebeneinander */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Bild des Vorteils */
.advantage-image {
  margin-right: 15px;
}

.image-icon {
  width: 60px; /* Größe des Icons */
  height: auto;
}

/* Inhalt (Titel und Beschreibung) */
.advantage-content {
  display: flex;
  flex-direction: column;
}

.advantage-title {
  font-size: 18px;
  font-weight: 600;
  color: #1b305f; /* Dunkleres Blau für die Titel */
  margin-bottom: 5px;

}

.advantage-description {
  font-size: 14px;
  color: #4a4a4a; /* Leicht graue Textfarbe für den Fließtext */
  max-width: 100%;
}

/* Anpassungen für kleinere Bildschirme */
@media (max-width: 768px) {
  .advantages-container {
    flex-direction: column;
    gap: 10px;
  }

  .advantage-item {
    width: 100%; /* Volle Breite für mobile Ansicht */
  }
}

/* Why Styling */
.why-section {
  display: flex;
  justify-content: space-between;
  padding: 50px 80px;
}

.why-content {
  display: flex;
  max-width: 1000px;
  margin: 0 auto;
}

.why-intro {
  width: 50%;
  padding: 20px;
  align-self: center;
}

.why-intro h3 {
  color: #666;
  text-align: center;
}

.why-intro a {
  color: #1b7ff6;
}

.small-text {
  color: #1b7ff6;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.why-title {
  font-size: 30px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  color: #1A1A1A;
  margin-top: 10px;
  font-weight: 700;
  text-align: center;
}

.why-description {
  font-size: 16px;
  color: #666;
  margin-top: 20px;
  margin-bottom: 40px;
  text-align: center;
}

.why-button {
  background-color: #E94235;
  color: white;
  padding: 15px 25px;
  border: none;
  font-size: 16px;
  margin-top: 30px;
  cursor: pointer;
}

.why-steps {
  display: flex;
  flex-direction: column;
  gap: 0px;
  width: 50%;
  padding: 20px;
}

.why-step {
  display: flex;
  align-items: center;
}

.step-icon {
  margin: 0 auto;
}

.step-icon img {
  min-width: 60px;
}

.step-content {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.step-number {
  color: #1b7ff6;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.step-title {
  font-size: 20px;
  font-weight: bold;
  margin: 5px 0;
}

.step-description {
  font-size: 16px;
  color: #666;
}

@media (max-width: 768px) {
  .why-section {
    padding: 10px;
  }

  .why-step {
    display: none !important; /* Hides the step completely */
  }

  .why-steps {
    display: none; /* Ensures the entire steps container is hidden */
  }

  .why-intro {
    width: 100%; /* Ensures full width for intro */
    margin: 0 auto; /* Centers the intro horizontally */
    text-align: center; /* Centers text inside the intro */
    padding: 1rem; /* Optional padding for better spacing */
  }

  .why-intro h1 {
    font-size: 1.5rem; /* Adjust font size for mobile */
  }

  .why-intro p {
    font-size: 1rem; /* Adjust paragraph size for readability */
  }

  .custom-blue-button {
    font-size: 16px;
  }
}
/* Case Overview */
.section.case-studies {
  padding: 50px 0;
}

.container-medium-714px {
  max-width: 714px;
  margin: 0 auto;
}

.case-studies-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.card.case-study {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
}

.case-study-card-content {
  padding-top: 20px;
}

.case-study-company {
  font-weight: bold;
}

.case-study-title-link {
  text-decoration: none;
  color: #000;
}

.increased-quantity {
  font-size: 1.5rem;
  font-weight: bold;
}

.divider {
  height: 2px;
  background-color: #ddd;
}

/* Case */
.container-default {
  max-width: 1000px;
  padding: 50px;
  margin: 0 auto;
}

.case-study-page {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.case-study-company-wrapper {
  display: flex;
  align-items: center;
}

.case-study-company-page {
  font-weight: bold;
  margin-right: 10px;
}

.case-study-date {
  color: #666;
}

.split-content {
  width: 100%;
}

.about-case-study-grid {
  display: flex;
  gap: 20px;
}

.about-case-study-wrapper {
  flex: 1 1;
}

.case-study-result-number {
  font-size: 1.5rem;
  font-weight: bold;
}

.image-wrapper.case-study-page {
  margin-top: 20px;
}

.project-overview-wrapper {
  margin-top: 50px;
}

.rich-text {
  line-height: 1.5;
}


/* About Section */
.about-section {
  text-align: center;
  padding: 50px 20px;
  background-color: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.about-heading h1 {
  font-size: 2.5rem;
  color: #202040;
  margin-bottom: 10px;
}

.about-heading h2 {
  color: #666;
}

.about-heading h2 a{
  color: #1b7ff6;
}

.about-team {
  font-size: 14px; /* Kleinere Schrift für den Mission-Text */
  color: #1b7ff6; /* Optional: Farbe für den kleinen Text */
  text-transform: uppercase; /* Optional: Alles groß schreiben */
  margin-bottom: 0.5rem;
}

.about-description {
  font-size: 1rem;
  color: black;
  margin-bottom: 40px;
  max-width: 700px;
  margin: 0 auto;
}

.bubble-wrapper {
  background-color: white;
  max-width: 900px;
  margin: 50px auto;
  margin-bottom: 0px;
  border-radius: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-wrap: wrap;
  justify-content: center; /* Center content horizontally */
  gap: 20px; /* Space between items */
  padding: 20px;
}

.statistics {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* Default: 4 columns */
  gap: 20px; /* Space between grid items */
  width: 100%;
}

.stat-item {
  background-color: none;
  border-radius: 10px;
  text-align: center;
  max-width: 200px;
}

.stat-item h2 {
  font-size: 2rem;
  color: #202040;
  margin-bottom: 0px;
}

.stat-item h2 span {
  color: #1b7ff6;
  font-size: 1.5rem;
}

.stat-item p {
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 0px;
}

@media (max-width: 768px) {
  .about-heading h1 {
    font-size: 28px;
  }
  .about-heading h2 {
    font-size: 18px;
  }
  .statistics {
    grid-template-columns: repeat(2, 1fr); /* Mobile: 2 columns */
  }
}


/* Team */
.team-section {
  text-align: center;
  padding: 50px 20px;
  background-color: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.team-heading {
  font-size: 14px; /* Kleinere Schrift für den Mission-Text */
  color: #1b7ff6; /* Optional: Farbe für den kleinen Text */
  text-transform: uppercase; /* Optional: Alles groß schreiben */
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.team-title {
  font-size: 2.5rem;
  color: black;
}

.team-section h3 {
  color: #666;
  margin-bottom: 40px;
}

.team-section a {
  color: #1b7ff6;
}

.team-members {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

.team-member-card {
  border-radius: 15px;
  padding: 0px;
  text-align: center;
  width: 300px;
}

.team-member-image {
  width: 100%;
  border-radius: 15px;
  height: 300px;
  object-fit: cover;
}

.team-member-name {
  font-size: 1.2rem;
  color: #202040;
  margin-top: 20px;
}

.team-member-title {
  color: #6c757d;
  font-size: 1rem;
  margin: 10px 0;
}

.linkedin-icon {
  color: #0077b5;
  font-size: 1.5rem;
  display: inline-block;
  margin-top: 10px;
  transition: color 0.3s ease;
}

.linkedin-icon:hover {
  color: #005582;
}

.team-member-card h3 {
  color: black;
  margin-bottom: 0px;
}

@media (max-width: 768px) {
  .team-section {
    margin-top: 50px;
  }

  .team-title {
    font-size: 28px;
  }

  .team-section h3 {
    font-size: 18px;
  }

  .team-member-image {
    width: 85%;
    height: auto ;
  }
}

/* Service */
.services-container {
  text-align: center;
  padding: 40px;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 80px;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.services-title {
  font-size: 2rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 10px;
}

.services-container h3 {
  color: #666;
  margin-bottom: 40px;
}

.services-container a {
  color: #1b7ff6;
}

.services-subtitle {
  font-size: 1rem;
  color: #666;
  margin-bottom: 40px;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Fixed 3 columns per row */
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  background-color: none;
  padding: 20px;
  border-radius: 10px;
  text-align: left; /* Left align content */
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.service-card:hover {
  background-color: #1b7ff6;
  color: white;
}

.service-card:hover .service-title,
.service-card:hover .service-description {
  color: white; 
}

.service-icon {
  width: 50px; /* Fixed width and height for the icon container */
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  background-color: #f0f0f0; /* Background color for the icon */
  border-radius: 10px; /* Rounded corners around the icon */
  margin-bottom: 15px;
  border: 1px solid #ddd; /* Border around the icon */
  color: #1b7ff6; /* Default icon color */
  transition: background-color 0.3s ease, color 0.3s ease;
}

.service-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.service-description {
  font-size: 0.9rem;
  color: #555;
}

/* Responsive Breakpoints */
@media (max-width: 992px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr); /* 2 columns on medium screens */
  }
  .services-title {
    font-size: 28px;
  }
  .services-container h3 {
    font-size: 20px;
  }
  .services-container {
    margin-top: 50px;
  }
}

@media (max-width: 600px) {
  .services-grid {
    grid-template-columns: 1fr; /* 1 column on small screens */
  }
  .services-title {
    font-size: 28px;
  }
  .services-container h3 {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .services-title {
    font-size: 28px;
  }
  .services-container h3 {
    font-size: 20px;
  }
}

/* Container layout */
.approach-container {
  width: 90%;
  max-width: 1100px;
  padding: 40px;
  margin: 0 auto;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.approach-header {
  text-align: center;
  margin-bottom: 40px;
}

.approach-header h2 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #2c2c54;
}

.approach-header p {
  font-size: 1.1rem;
  color: #666;
  margin: 0 auto;
  margin-bottom: 20px;
  max-width: 70%;
}

.tab-menu {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 20px;
}

.tab-item {
  font-size: 1rem;
  cursor: pointer;
  color: #888;
  padding-bottom: 5px;
  border-bottom: 2px solid transparent;
  transition: color 0.3s, border-color 0.3s;
}

.tab-item.active {
  color: #1b7ff6;
  border-bottom: 2px solid #1b7ff6;
}

/* Content Section */
.approach-content {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  min-height: 400px;
}

.content-left {
  width: 60%;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  text-align: left;
  position: relative; /* Allows the button to be absolutely positioned */
  min-height: 400px;
}

.content-left small {
  text-align: left;
  color: #1b7ff6;
  margin-bottom: 10px;
}

.content-left h4 {
  font-size: 1.2rem;
  color: black;
  margin-bottom: 20px;
}

.content-left p {
  font-size: 1rem;
  color: #333;
  margin-bottom: 15px;
}

/* Fixed CTA Button at the bottom-left */
.cta-button {
  position: absolute;
  bottom: 20px;
  left: 30px;
  display: inline-block;
  background-color: #1b7ff6;
  color: white;
  padding: 12px 25px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
}

.cta-button:hover {
  background-color: #004bbf;
}

/* Right Section: Image */
.content-right {
  width: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-right img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
}

/* Cost Component */
.table-container {
  width: 85%;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 80px;
}

.table-container h1 {
  text-align: center;
}

.table-container h3 {
  text-align: center;
  color: #666;
}

.table-container a {
  color: #1b7ff6;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 14px;
  margin-top: 40px;
}

.styled-table th,
.styled-table td {
  padding: 12px 25px;
  border: 1px solid #dddddd;
  font-weight: 600;
  min-height: 60 px; /* Set minimum height for rows */
}

.styled-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}

.table-logo {
  width: 45%;
}

.table-border {
  height: 100%;
  width: 30%;
  border: 1px solid #1b7ff6;
}

.styled-table td.right-column, 
.styled-table td.middle-column {
  text-align: center !important;
  width: 33%;
}

.styled-table td.middle-column {
  border-left: 3px solid #1b7ff6;
  border-right: 3px solid #1b7ff6;
}

.styled-table td.middle-column a {
  cursor: pointer;
  text-decoration: none;
  color: black;
  transition: transform 0.3s ease;
}

.styled-table th.middle-heading {
  border-top: 3px solid #1b7ff6;
  border-left: 3px solid #1b7ff6;
  border-right: 3px solid #1b7ff6;
}

.styled-table tr:last-child td.middle-column {
  border-bottom: 3px solid #1b7ff6;
}

.odd-row {
  background-color: #f2f2f2;
}

.even-row {
  background-color: #ffffff;
}

.toggle-container {
  text-align: right;
  margin-top: 20px;
}

.toggle-button {
  padding: 10px 20px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  cursor: pointer;
  background-color: transparent;
  color: black;
  border: none;
  transition: background-color 0.5s ease-in-out;
  font-weight: 600;
}

.toggle-button:hover {
  text-decoration: underline;
  color: #1b7ff6;
}

.styled-table tbody tr {
  height: 60px; /* Set a fixed height for body rows */
}

/* Adjust the table for mobile screens */
@media (max-width: 768px) {
  /* Reduce container padding and margins */
  .table-container {
    width: 95%; /* Use more screen width */
    margin: 50px auto; /* Smaller top and bottom margin */
  }

  /* Resize headings */
  .table-container h1 {
    font-size: 20px; /* Smaller font size */
  }

  .cost-heading {
    font-size: 28px !important;
  }

  .table-container h3 {
    font-size: 14px; /* Smaller font size */
    line-height: 1.4; /* Adjust line height for better readability */
  }

  .cost-subheading {
    font-size: 18px !important;
  }


  /* Adjust table font sizes and padding */
  .styled-table {
    font-size: 12px; /* Smaller text for the table */
  }

  .styled-table th, 
  .styled-table td {
    padding: 8px 15px; /* Reduce cell padding */
    font-size: 10px;
  }

  /* Reduce logo size */
  .table-logo {
    width: 50%; /* Smaller width for the logo */
  }

  /* Middle column adjustments */
  .styled-table td.middle-column {
    border-left: 3px solid #1b7ff6; /* Thinner border */
    border-right: 3px solid #1b7ff6; /* Thinner border */
  }

  /* Adjust the toggle button */
  .toggle-container {
    text-align: center; /* Center the button on mobile */
  }

  .toggle-button {
    font-size: 14px; /* Smaller font size for the button */
    padding: 8px 15px; /* Reduce button padding */
  }
}

/* Owner */
.owner-section {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.owner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  gap: 20px; /* Adds spacing between image and content */
}

.owner-image, .owner-content {
  width: 50%; /* Ensures both image and content occupy equal width */
  box-sizing: border-box;
}

.owner-image img {
  width: 90%; /* Ensures the image fills its container */
  height: auto;
  padding: 10px;
}

.owner-content {
  padding: 40px;
  max-width: 100%; /* Remove the max-width to avoid restricting content width */
  box-sizing: border-box;
}

.owner-content h2 {
  font-size: 30px;
  margin-bottom: 1rem;
}

.owner-content p {
  font-size: 1rem;
  width: 70%;
  margin-bottom: 1.5rem;
}

.owner-button-space button {
  background-color: #1b7ff6;
  color: white;
  padding: 15px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.owner-button-space button:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .owner-section {
    margin-top: 0px;
  }

  .owner-container {
    display: flex;
    flex-direction: column; /* Stack content vertically */
    align-items: center; /* Center-align all content horizontally */
    justify-content: center; /* Center-align vertically */
    padding: 20px; /* Adjust padding */
    margin: 0 auto; /* Center the section */
    margin-top: 0px;
    width: 100%; /* Ensure full width */
    max-width: 100%; /* Prevent overflow */
    box-sizing: border-box; /* Include padding and border in width */
    text-align: center; /* Center-align text */
    overflow-x: hidden; /* Prevent horizontal scrolling */
  }

  .owner-image {
    width: 80%; /* Take full width on smaller screens */
  }

  .owner-content {
    text-align: center; /* Center align text on mobile */
    padding: 10px; /* Adjust padding for smaller screens */
    width: 70%;
  }

  .owner-content h2 {
    font-size: 24px; /* Adjust font size */
  }

  .owner-content p {
    font-size: 14px; /* Adjust font size */
    width: 100%; /* Full width for text */
  }

  .owner-button-space button {
    width: 100%; /* Full width button for mobile */
  }
}


/* Location */

.location-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px;
}

.location-wrapper h1 {
  text-align: center;
  margin-bottom: 40px;
} 

.location-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
}

.location-box {
  border: 1px solid black;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  width: 150px;
  height: 200px;
  position: relative; /* For positioning child elements */
  display: flex;
  justify-content: center; /* Centers the image horizontally */
  align-items: center; /* Centers the image vertically */
  transition: transform 0.3s, box-shadow 0.3s;
}

.location-image {
  width: 65%;
  height: auto;
  object-fit: cover;
}

.location-box p {
  position: absolute; /* Position paragraph at the bottom */
  bottom: 10px; /* Adjust spacing from the bottom */
  left: 0;
  right: 0;
  margin: 0;
  text-align: center;
  font-size: 20px; /* Adjust font size if needed */
  color: #333; /* Example color */
}

.location-box:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-color: #1b7ff6;
}

@media (max-width: 768px) {
  .location-wrapper {
    padding: 10px;
    margin-top: 50px;
  }

  .location-box {
    padding: 15px;
    width: 100px;
    height: 133px;
  }

  .location-image {
    width: 60%; /* Adjust image size for smaller screens */
  }

  .location-box p {
    font-size: 14px; /* Adjust font size for smaller screens */
  }
}

/* src/components/ThankYou.css */
.thank-you-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 300px;
  background-color: none;
  padding: 20px;
}

.thank-you-container p {
  max-width: 550px;
}

.icon-container img {
  width: 300px;
  margin-bottom: 20px;
  padding: 20px;
}

/*How it works*/
.how-it-works-container {
  text-align: center;
  margin-top: 100px;
  margin-bottom: 100px;
}

.how-it-works-subtitle {
  color: #666;
}

.how-it-works-subtitle a{
  color: #1b7ff6;
}

.how-it-works-carousel {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  position: relative;
  overflow: hidden;
  max-width: 600px;
}

.how-it-works-nav {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

.how-it-works-nav:hover {
  color: #1b7ff6;
  transform: scale(1.2);
}

.how-it-works-nav.disabled {
  cursor: not-allowed;
  opacity: 0;
  pointer-events: none; /* Prevent any interaction */

}

.how-it-works-step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
  transition: transform 0.5s ease, opacity 0.5s ease;
  opacity: 1;
}

.how-it-works-text {
  font-size: 1.5rem;
  color: #333;
  max-width: 100%;
  text-align: center;
  height: 100px; /* Set a fixed height for all steps */
  display: flex; /* Center align text vertically */
  align-items: center;
  justify-content: center;
}

.how-it-works-step-content.animate {
  animation: slideIn 0.5s forwards ease;
}

@keyframes slideIn {
  0% {
    opacity: 0;
    transform: translateX(20%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.how-it-works-image {
  width: 70%;
  margin-bottom: 15px;
}

.how-it-works-text {
  font-size: 1.5rem;
  color: #333;
  max-width: 100%;
}

.how-it-works-indicators {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.how-it-works-indicator {
  height: 30px;
  width: 30px;
  background-color: #ddd;
  color: #333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  cursor: pointer;
  font-size: 1rem; 
  font-weight: bold;
}

.how-it-works-indicator.active {
  background-color: #1b7ff6;
  color: #fff;
}

@media (max-width: 768px) {
  .how-it-works-container {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 100px;
    padding: 10px;
  }

  .how-it-works-title {
    font-size: 28px;
  }

  .how-it-works-subtitle {
    padding-left: 40px;
    padding-right: 40px;
  }

  .how-it-works-text {
    font-size: 1.2rem; /* Smaller text for mobile */
    height: 80px; /* Adjust height for smaller screens */
    }

}


/* Kontakt */
.contact {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  margin: 0 auto;
  max-width: 950px;
  width: 100%;
}

.contact-content {
  position: relative;
  height: auto;
  text-align: left;
  padding: 20px;
  max-width: 50%;
}


.contact-paragraph {
  width: 85%;
}

@media (max-width: 768px) {
  .contact {
    display: flex;
    flex-direction: column; /* Stack content vertically */
    justify-content: center; /* Center items vertically */
    align-items: center; /* Center items horizontally */
    padding: 0;
    margin: 0 auto;
    width: 100%; /* Full width for the container */
    overflow: hidden; /* Prevent content overflow */
  }

  .contact-content {
    max-width: 100%;
  }

  .contact-heading {
    font-size: 28px;
    text-align: center;
  }
  .contact-paragraph {
    font-size: 16px;
    text-align: center;
    margin: 0 auto;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;EACE,sBAAsB,EAAE,gDAAgD;EACxE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;IACI,SAAS;IACT,UAAU;IACV,kBAAkB,EAAE,iCAAiC;AACzD;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;AAC9C;;;AAGA,yBAAyB;AACzB;EACE,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE;IACE,aAAa,EAAE,0CAA0C;IACzD,wBAAwB,EAAE,wBAAwB;IAClD,cAAc,EAAE,WAAW;IAC3B,gBAAgB;IAChB,cAAc;EAChB;AACF;AACA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE;IACE,aAAa,EAAE,0CAA0C;IACzD,wBAAwB,EAAE,wBAAwB;IAClD,cAAc,EAAE,WAAW;IAC3B,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,iCAAiC;AACjC;EACE;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,2CAA2C;EAC7C;AACF;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,UAAU;IACV,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;AAEF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,qEAAqE;EACrE,kBAAkB;EAClB,aAAa;AACf;;;AAGA,qCAAqC;AACrC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,YAAY,EAAE,eAAe;EAC7B,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yCAAyC,EAAE,oCAAoC;EAC/E,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,qEAAqE;EACrE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;;AAGA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,qDAAqD;EACrD,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,aAAa,EAAE,qBAAqB;EACpC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa,EAAE,0CAA0C;EACzD,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B,EAAE,0DAA0D;EAC1F,mBAAmB,EAAE,uBAAuB;EAC5C,YAAY,EAAE,qCAAqC;EACnD,WAAW,EAAE,eAAe;AAC9B;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,gBAAgB,EAAE,2BAA2B;EAC7C,YAAY,EAAE,cAAc;EAC5B,eAAe,EAAE,qBAAqB;EACtC,eAAe,EAAE,sBAAsB;EACvC,aAAa,EAAE,0BAA0B;EACzC,mBAAmB,EAAE,sBAAsB;EAC3C,yBAAyB,EAAE,gCAAgC;EAC3D,YAAY,EAAE,wCAAwC;EACtD,WAAW,EAAE,oCAAoC;EACjD,iBAAiB,EAAE,qCAAqC;EACxD,UAAU,EAAE,+CAA+C;AAC7D;;AAEA;EACE,cAAc,EAAE,yCAAyC;EACzD,SAAS,EAAE,+BAA+B;EAC1C,WAAW,EAAE,wCAAwC;EACrD,YAAY,EAAE,wCAAwC;AACxD;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB,EAAE,2BAA2B;EACnD,mBAAmB;EACnB,uBAAuB,EAAE,uBAAuB;EAChD,aAAa,EAAE,0CAA0C;EACzD,aAAa;EACb,sBAAsB,EAAE,gDAAgD;AAC1E;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAE,2BAA2B;EACnD,SAAS,EAAE,8BAA8B;EACzC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qBAAqB,EAAE,qBAAqB;EAC5C,YAAY,EAAE,eAAe;EAC7B,iBAAiB,EAAE,cAAc;EACjC,iBAAiB,EAAE,cAAc;AACnC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB,EAAE,uBAAuB;EAC3C,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB,EAAE,cAAc;EACjC,eAAe,EAAE,cAAc;EAC/B,qDAAqD,EAAE,wBAAwB;EAC/E,yCAAyC,EAAE,kBAAkB;EAC7D,gBAAgB;AAClB;;AAEA;EACE,qBAAqB,EAAE,8BAA8B;EACrD,yCAAyC,EAAE,6BAA6B;AAC1E;;AAEA,eAAe;AACf;EACE,cAAc;EACd,kBAAkB,EAAE,qCAAqC;EACzD,SAAS,EAAE,wBAAwB;EACnC,WAAW,EAAE,0BAA0B;EACvC,gBAAgB,EAAE,2BAA2B;EAC7C,YAAY,EAAE,cAAc;EAC5B,eAAe,EAAE,qBAAqB;EACtC,eAAe,EAAE,sBAAsB;AACzC;;AAEA,qBAAqB;AACrB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,YAAY,EAAE,0CAA0C;EACxD,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY,EAAE,0CAA0C;EACxD,iBAAiB,EAAE,2BAA2B;EAC9C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY,EAAE,0CAA0C;EACxD,iBAAiB,EAAE,2BAA2B;EAC9C,eAAe;EACf,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE;IACE,aAAa;IACb,sBAAsB,EAAE,6BAA6B;IACrD,uBAAuB,EAAE,4BAA4B;IACrD,mBAAmB,EAAE,8BAA8B;IACnD,UAAU;IACV,cAAc;IACd,WAAW,EAAE,iCAAiC;IAC9C,gBAAgB,EAAE,6BAA6B;EACjD;;EAEA;IACE,eAAe;IACf,gBAAgB,EAAE,0BAA0B;EAC9C;;EAEA;IACE,WAAW,EAAE,gCAAgC;IAC7C,eAAe,EAAE,iDAAiD;IAClE,YAAY,EAAE,0BAA0B;IACxC,cAAc,EAAE,oDAAoD;IACpE,SAAS,EAAE,+BAA+B;IAC1C,kBAAkB,EAAE,kDAAkD;EACxE;;EAEA;IACE,UAAU;IACV,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe,EAAE,yCAAyC;EAC5D;;EAEA;IACE,YAAY,EAAE,0CAA0C;IACxD,iBAAiB,EAAE,2BAA2B;IAC9C,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY,EAAE,0CAA0C;IACxD,iBAAiB,EAAE,2BAA2B;IAC9C,eAAe;IACf,gBAAgB;EAClB;AACF;;;AAGA,oBAAoB;AACpB;EACE,aAAa,EAAE,mBAAmB;EAClC,sBAAsB,EAAE,sCAAsC;EAC9D,2BAA2B,EAAE,gCAAgC;EAC7D,mBAAmB,EAAE,qCAAqC;EAC1D,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB,EAAE,qCAAqC;EACxD,WAAW;EACX,YAAY,EAAE,uCAAuC;EACrD,4CAA4C;EAC5C,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,mBAAmB,EAAE,mCAAmC;EACxD,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;;AAGA,cAAc;AACd;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,uBAAuB,EAAE,oCAAoC;EAC7D,eAAe,EAAE,wCAAwC;EACzD,SAAS,EAAE,uCAAuC;AACpD;;AAEA;EACE,aAAa,EAAE,0CAA0C;EACzD,eAAe,EAAE,wCAAwC;EACzD,WAAW,EAAE,iCAAiC;AAChD;;AAEA;;EAEE,SAAO,EAAE,gCAAgC;EACzC,gBAAgB,EAAE,sCAAsC;EACxD,gBAAgB,EAAE,sCAAsC;EACxD,aAAa,EAAE,8CAA8C;EAC7D,eAAe,EAAE,gDAAgD;EACjE,uBAAuB,EAAE,8BAA8B;EACvD,mBAAmB,EAAE,iCAAiC;EACtD,kBAAkB,EAAE,qCAAqC;AAC3D;;AAEA;;EAEE,kBAAkB,EAAE,kCAAkC;AACxD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa,EAAE,oCAAoC;EACnD,YAAY;EACZ,eAAe;EACf,mBAAmB,EAAE,qCAAqC;EAC1D,SAAO,EAAE,wCAAwC;EACjD,gBAAgB,EAAE,mCAAmC;EACrD,gBAAgB,EAAE,mCAAmC;EACrD,eAAe,EAAE,wCAAwC;EACzD,kBAAkB,EAAE,iCAAiC;EACrD,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B,EAAE,gCAAgC;AAChE;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;AAEF;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;;AAEzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB,EAAE,sDAAsD;EAC7E,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY,EAAE,2BAA2B;EACzC,kBAAkB,EAAE,+CAA+C;AACrE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB,EAAE,6BAA6B;EAC/C,iBAAiB,EAAE,8BAA8B;EACjD,gBAAgB,EAAE,kEAAkE;EACpF,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;;;AAGA,mBAAmB;AACnB;EACE,sBAAsB,EAAE,uBAAuB;EAC/C,YAAY,EAAE,mBAAmB;EACjC,aAAa,EAAE,iBAAiB;EAChC,4CAA4C,EAAE,eAAe;EAC7D,iBAAiB,EAAE,oBAAoB;EACvC,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa,EAAE,uBAAuB;EACtC,8BAA8B,EAAE,4BAA4B;EAC5D,uBAAuB,EAAE,6BAA6B;AACxD;;AAEA;EACE,YAAY,EAAE,cAAc;AAC9B;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,SAAS,EAAE,iCAAiC;AAC9C;;AAEA;EACE,aAAa,EAAE,wBAAwB;EACvC,sBAAsB,EAAE,8BAA8B;AACxD;;AAEA;EACE,qBAAqB,EAAE,oCAAoC;AAC7D;;AAEA;EACE,gBAAgB,EAAE,6BAA6B;EAC/C,UAAU,EAAE,iBAAiB;AAC/B;;AAEA;EACE,qBAAqB,EAAE,+BAA+B;AACxD;;AAEA;EACE,qBAAqB,EAAE,0BAA0B;EACjD,YAAY,EAAE,mBAAmB;EACjC,sBAAsB,EAAE,wBAAwB;AAClD;;AAEA;EACE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,WAAW,EAAE,4CAA4C;EACzD,gBAAgB,EAAE,wCAAwC;EAC1D,aAAa,EAAE,wBAAwB;EACvC,eAAe,EAAE,mDAAmD;AACtE;;AAEA;EACE,aAAa,EAAE,uBAAuB;EACtC,WAAW,EAAE,gCAAgC;EAC7C,8BAA8B,EAAE,qDAAqD;EACrF,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,SAAO,EAAE,wCAAwC;EACjD,kBAAkB,EAAE,uBAAuB;EAC3C,cAAc,EAAE,iCAAiC;AACnD;;AAEA;EACE,cAAc,EAAE,sCAAsC;EACtD,SAAS,EAAE,gCAAgC;EAC3C,WAAW,EAAE,qBAAqB;EAClC,sBAAsB,EAAE,sBAAsB;AAChD;;AAEA;EACE,kBAAkB,EAAE,oBAAoB;EACxC,gBAAgB,EAAE,kBAAkB;AACtC;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE;IACE,YAAY,EAAE,cAAc;EAC9B;AACF;;AAEA,kBAAkB;AAClB,kBAAkB;AAClB;EACE,aAAa,EAAE,sBAAsB;EACrC,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc,EAAE,2BAA2B;IAC3C,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB,EAAE,mCAAmC;EACrD,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,2BAA2B;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB,EAAE,uBAAuB;EAC/C,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,kCAAkC;EACzD,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,4BAA4B;EAC3C,8BAA8B,EAAE,0BAA0B;EAC1D,SAAS;AACX;;AAEA,oEAAoE;AACpE;EACE;IACE,sBAAsB,EAAE,6BAA6B;IACrD,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe,EAAE,oBAAoB;EACrC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB,EAAE,0BAA0B;AAChD;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,4BAA4B;EAC3C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB,EAAE,0CAA0C;IAC/D,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB,EAAE,qCAAqC;IACzD,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,uBAAuB;EACxC;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB,EAAE,oCAAoC;EAC7D,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa,EAAE,oCAAoC;EACnD,YAAY;EACZ,eAAe;EACf,mBAAmB,EAAE,qCAAqC;EAC1D,gBAAgB,EAAE,mCAAmC;EACrD,gBAAgB,EAAE,mCAAmC;EACrD,eAAe,EAAE,wCAAwC;EACzD,kBAAkB,EAAE,iCAAiC;EACrD,iBAAiB;EACjB,qDAAqD;EACrD,yCAAyC,EAAE,kBAAkB;AAC/D;;AAEA;EACE,qBAAqB;EACrB,yCAAyC,EAAE,gCAAgC;AAC7E;;;AAGA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB,EAAE,oCAAoC;EAC7D,SAAS,EAAE,2BAA2B;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa,EAAE,oCAAoC;EACnD,YAAY;EACZ,eAAe;EACf,mBAAmB,EAAE,qCAAqC;EAC1D,gBAAgB,EAAE,mCAAmC;EACrD,gBAAgB,EAAE,mCAAmC;EACrD,eAAe,EAAE,wCAAwC;EACzD,kBAAkB,EAAE,iCAAiC;EACrD,iBAAiB;EACjB,mBAAmB;EACnB,qDAAqD;EACrD,yCAAyC,EAAE,kBAAkB;AAC/D;;AAEA;EACE,qBAAqB;EACrB,yCAAyC,EAAE,gCAAgC;AAC7E;;;AAGA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB,EAAE,wDAAwD;EAC3E,YAAY,EAAE,0DAA0D;AAC1E;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;;AAGA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B,EAAE,2BAA2B;EACxD,iBAAiB;EACjB,iBAAiB,EAAE,oEAAoE;EACvF,sBAAsB,EAAE,kDAAkD;AAC5E;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,aAAa,EAAE,gCAAgC;EAC/C,mBAAmB,EAAE,oCAAoC;EACzD,4CAA4C;AAC9C;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA,gEAAgE;AAChE;EACE,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa,EAAE,2CAA2C;EAC1D,gBAAgB,EAAE,iCAAiC;EACnD,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA,8CAA8C;AAC9C;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B,EAAE,gBAAgB;AAC9C;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB,OAAO,gCAAgC;EAChE,YAAY;EACZ,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB,cAAc,iDAAiD;AACnF;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,SAAO,EAAE,2CAA2C;EACpD,aAAa;EACb,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,gBAAgB,EAAE,+BAA+B;EACjD,eAAe;EACf,gEAAgE,EAAE,8BAA8B;AAClG;;;AAGA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,qCAAqC;AAC5D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,gBAAgB,EAAE,+BAA+B;EACjD,eAAe;EACf,gEAAgE,EAAE,8BAA8B;EAChG,mBAAmB;AACrB;;AAEA;EACE,qBAAqB,EAAE,uCAAuC;EAC9D,aAAa;AACf;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,gBAAgB;EAChB,4CAA4C;AAC9C;;;AAGA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS,EAAE,iCAAiC;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,gBAAgB,EAAE,+BAA+B;EACjD,eAAe;EACf,gEAAgE,EAAE,8BAA8B;EAChG,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,4CAA4C;AAC9C;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW,EAAE,0CAA0C;IACvD,sBAAsB,EAAE,8CAA8C;EACxE;;EAEA;IACE,WAAW,EAAE,uCAAuC;IACpD,sBAAsB,EAAE,oCAAoC;EAC9D;;EAEA;IACE,WAAW,EAAE,oCAAoC;IACjD,eAAe,EAAE,2CAA2C;IAC5D,sBAAsB,EAAE,yDAAyD;EACnF;;EAEA,wEAAwE;EACxE;IACE,eAAe,EAAE,gDAAgD;EACnE;AACF;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,oDAAoD;EACrE,4CAA4C;EAC5C,YAAY,EAAE,8BAA8B;EAC5C,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,4CAA4C;IAC5C,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,oDAAoD;IACrE,4CAA4C;IAC5C,YAAY,EAAE,8BAA8B;IAC5C,mBAAmB;EACrB;;AAEF;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;;;AAIA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB,EAAE,2CAA2C;EACjE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,0CAA0C;EACxD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,mCAAmC;EACjD,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY,EAAE,6CAA6C;EAC3D,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAE,0BAA0B;EAC/C,iBAAiB;EACjB,WAAW;EACX,gBAAgB,EAAE,qCAAqC;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,uEAAuE;AAC9F;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uDAAuD;EACvD,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,qCAAqC;AACrC;;EAEE,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY;AACd;AACA;;EAEE,yBAAyB,EAAE,6BAA6B;EACxD,YAAY;AACd;;AAEA;;EAEE,yBAAyB,EAAE,wBAAwB;EACnD,YAAY;AACd;;AAEA,2DAA2D;AAC3D;;;EAGE,YAAY;AACd;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc,EAAE,mCAAmC;EACnD,eAAe,EAAE,+BAA+B;EAChD,YAAY,EAAE,2BAA2B;AAC3C;;;AAGA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB,EAAE,2CAA2C;IACjE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAE,0CAA0C;IACxD,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAE,mCAAmC;IACjD,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB,EAAE,kCAAkC;IACpD,cAAc,EAAE,gCAAgC;EAClD;;EAEA;IACE,QAAQ,EAAE,8CAA8C;IACxD,8BAA8B,EAAE,uBAAuB;IACvD,aAAa,EAAE,wBAAwB;IACvC;;EAEF;IACE,aAAa;IACb,mBAAmB,EAAE,uEAAuE;EAC9F;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,oBAAoB;AACpB;EACE,aAAa,EAAE,mEAAmE;EAClF,8BAA8B,EAAE,oCAAoC;EACpE,mBAAmB,EAAE,0BAA0B;EAC/C,aAAa,EAAE,oCAAoC;EACnD,cAAc;EACd,gBAAgB,EAAE,gCAAgC;EAClD,WAAW,EAAE,iBAAiB;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,sCAAsC;AACxD;;AAEA;EACE,eAAe,EAAE,0CAA0C;EAC3D,cAAc,EAAE,yCAAyC;EACzD,yBAAyB,EAAE,mCAAmC;EAC9D,qBAAqB;AACvB;;AAEA;EACE,eAAe,EAAE,yBAAyB;EAC1C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe,EAAE,8CAA8C;EAC/D,gBAAgB,EAAE,sCAAsC;AAC1D;;AAEA;EACE,eAAe,EAAE,iDAAiD;EAClE,YAAY,EAAE,wCAAwC;EACtD,iBAAiB,EAAE,mCAAmC;EACtD,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA,mBAAmB;AACnB,iCAAiC;AACjC;EACE;IACE,aAAa;IACb,sBAAsB,EAAE,6BAA6B;IACrD,mBAAmB,EAAE,0CAA0C;IAC/D,uBAAuB,EAAE,4BAA4B;IACrD,aAAa,EAAE,mBAAmB;IAClC,cAAc,EAAE,uBAAuB;IACvC,gBAAgB;IAChB,WAAW,EAAE,sBAAsB;IACnC,eAAe,EAAE,qBAAqB;IACtC,sBAAsB,EAAE,wCAAwC;IAChE,kBAAkB,EAAE,sBAAsB;IAC1C,kBAAkB,EAAE,iCAAiC;EACvD;;EAEA;IACE,cAAc,EAAE,oCAAoC;IACpD,cAAc,EAAE,gCAAgC;EAClD;;EAEA;IACE,eAAe,EAAE,kCAAkC;IACnD,mBAAmB,EAAE,gCAAgC;EACvD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe,EAAE,qCAAqC;IACtD,gBAAgB,EAAE,yBAAyB;IAC3C,mBAAmB,EAAE,kCAAkC;EACzD;;EAEA;IACE,UAAU,EAAE,yBAAyB;IACrC,gBAAgB,EAAE,wCAAwC;IAC1D,YAAY,EAAE,0BAA0B;IACxC,cAAc,EAAE,qBAAqB;IACrC,cAAc,EAAE,kCAAkC;EACpD;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB,EAAE,mCAAmC;EACvD,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB,EAAE,yBAAyB;EAC7C,mBAAmB,EAAE,8CAA8C;AACrE;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW,EAAE,6DAA6D;EAC1E,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,mCAAmC;EAC9C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,mCAAmC;EAC9C,eAAe;AACjB;;AAEA;EACE,WAAW,EAAE,kCAAkC;EAC/C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,qDAAqD;AACxE;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;GACC,eAAe;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB,EAAE,sDAAsD;EAC1E;EACA;IACE,eAAe;EACjB;AACF;;;;AAIA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sBAAsB,EAAE,2BAA2B;EACnD,mBAAmB,EAAE,wCAAwC;EAC7D,cAAc;EACd,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,UAAU,EAAE,mEAAmE;EAC/E,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW,EAAE,oBAAoB;EACjC,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,iCAAiC;EACjD,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,6CAA6C;EAC7D,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW,EAAE,oCAAoC;EACnD;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB,EAAE,8BAA8B;EAC1D;;EAEA;IACE,aAAa,EAAE,iDAAiD;EAClE;;EAEA;IACE,WAAW,EAAE,iCAAiC;IAC9C,cAAc,EAAE,mCAAmC;IACnD,kBAAkB,EAAE,kCAAkC;IACtD,aAAa,EAAE,wCAAwC;EACzD;;EAEA;IACE,iBAAiB,EAAE,gCAAgC;EACrD;;EAEA;IACE,eAAe,EAAE,0CAA0C;EAC7D;;EAEA;IACE,eAAe;EACjB;AACF;AACA,kBAAkB;AAClB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe,EAAE,0CAA0C;EAC3D,cAAc,EAAE,yCAAyC;EACzD,yBAAyB,EAAE,mCAAmC;EAC9D,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,uBAAuB,EAAE,gCAAgC;EACzD,SAAS,EAAE,wBAAwB;EACnC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,uBAAuB;EAC9D,SAAS,EAAE,6BAA6B;EACxC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qCAAqC,EAAE,sBAAsB;EAC/D;AACF;;;AAGA,SAAS;AACT;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,eAAe,EAAE,0CAA0C;EAC3D,cAAc,EAAE,yCAAyC;EACzD,yBAAyB,EAAE,mCAAmC;EAC9D,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,4BAA4B;EACnE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB,EAAE,uBAAuB;EACzC,uDAAuD;EACvD,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,kDAAkD;EAC/D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB,EAAE,kCAAkC;EAC7D,mBAAmB,EAAE,oCAAoC;EACzD,mBAAmB;EACnB,sBAAsB,EAAE,2BAA2B;EACnD,cAAc,EAAE,uBAAuB;EACvC,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC,EAAE,gCAAgC;EACzE;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B,EAAE,8BAA8B;EAC5D;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE,kDAAkD;EACtE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB,EAAE,gCAAgC;AACrD;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY,EAAE,qCAAqC;AACrD;;AAEA,wCAAwC;AACxC;EACE,yCAAyC;EACzC;IACE,UAAU,EAAE,0BAA0B;IACtC,iBAAiB,EAAE,kCAAkC;EACvD;;EAEA,oBAAoB;EACpB;IACE,eAAe,EAAE,sBAAsB;EACzC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe,EAAE,sBAAsB;IACvC,gBAAgB,EAAE,8CAA8C;EAClE;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA,wCAAwC;EACxC;IACE,eAAe,EAAE,+BAA+B;EAClD;;EAEA;;IAEE,iBAAiB,EAAE,wBAAwB;IAC3C,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,UAAU,EAAE,+BAA+B;EAC7C;;EAEA,8BAA8B;EAC9B;IACE,8BAA8B,EAAE,mBAAmB;IACnD,+BAA+B,EAAE,mBAAmB;EACtD;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB,EAAE,gCAAgC;EACtD;;EAEA;IACE,eAAe,EAAE,qCAAqC;IACtD,iBAAiB,EAAE,0BAA0B;EAC/C;AACF;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,SAAS,EAAE,2CAA2C;AACxD;;AAEA;EACE,UAAU,EAAE,sDAAsD;EAClE,sBAAsB;AACxB;;AAEA;EACE,UAAU,EAAE,0CAA0C;EACtD,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,4DAA4D;EAC7E,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,qDAAqD;EACrD,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB,EAAE,6BAA6B;IACrD,mBAAmB,EAAE,0CAA0C;IAC/D,uBAAuB,EAAE,4BAA4B;IACrD,aAAa,EAAE,mBAAmB;IAClC,cAAc,EAAE,uBAAuB;IACvC,eAAe;IACf,WAAW,EAAE,sBAAsB;IACnC,eAAe,EAAE,qBAAqB;IACtC,sBAAsB,EAAE,wCAAwC;IAChE,kBAAkB,EAAE,sBAAsB;IAC1C,kBAAkB,EAAE,iCAAiC;EACvD;;EAEA;IACE,UAAU,EAAE,uCAAuC;EACrD;;EAEA;IACE,kBAAkB,EAAE,gCAAgC;IACpD,aAAa,EAAE,uCAAuC;IACtD,UAAU;EACZ;;EAEA;IACE,eAAe,EAAE,qBAAqB;EACxC;;EAEA;IACE,eAAe,EAAE,qBAAqB;IACtC,WAAW,EAAE,wBAAwB;EACvC;;EAEA;IACE,WAAW,EAAE,iCAAiC;EAChD;AACF;;;AAGA,aAAa;;AAEb;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAE,mCAAmC;EACvD,aAAa;EACb,uBAAuB,EAAE,mCAAmC;EAC5D,mBAAmB,EAAE,iCAAiC;EACtD,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB,EAAE,qCAAqC;EACzD,YAAY,EAAE,mCAAmC;EACjD,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,eAAe,EAAE,+BAA+B;EAChD,WAAW,EAAE,kBAAkB;AACjC;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU,EAAE,0CAA0C;EACxD;;EAEA;IACE,eAAe,EAAE,yCAAyC;EAC5D;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB,EAAE,4BAA4B;;AAEpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa,EAAE,qCAAqC;EACpD,aAAa,EAAE,iCAAiC;EAChD,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB,EAAE,4BAA4B;IAC/C,YAAY,EAAE,sCAAsC;IACpD;;AAEJ;;;AAGA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB,EAAE,6BAA6B;IACrD,uBAAuB,EAAE,4BAA4B;IACrD,mBAAmB,EAAE,8BAA8B;IACnD,UAAU;IACV,cAAc;IACd,WAAW,EAAE,iCAAiC;IAC9C,gBAAgB,EAAE,6BAA6B;EACjD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;AACF","sourcesContent":["/* App */\n.app {\n  background-color: #fff; /* Weißer Hintergrund für die gesamte Webseite */\n  min-height: 100vh;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.body {\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\nhtml, body {\n    margin: 0;\n    padding: 0;\n    overflow-x: hidden; /* Prevent horizontal scrolling */\n}\n\n/* Generische Einstellungen für Text */\nh1, h2, h3, p {\n  margin: 0 0 1rem 0;\n  color: black;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n\n/* Hero Section Wrapper */\n.hero-wrapper {\n  background-color: rgba(230, 230, 230, 1);\n  border-radius: 25px;\n  padding: 3rem;\n  margin: 0 auto;\n  margin-top: 15px;\n  width: 85%;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n  .hero-wrapper {\n    padding: 1rem; /* Adjust this to avoid alignment issues */\n    width: calc(100% - 2rem); /* Account for padding */\n    margin: 0 auto; /* Center */\n    margin-top: 15px;\n    max-width: 85%;\n  }\n}\n/* Blauer Section Wrapper */\n.content-wrapper {\n  background-color: #1b7ff6;\n  border-radius: 25px;\n  padding: 3rem;\n  margin: 15px auto;\n  width: 90%;\n  max-width: 85%;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n  .content-wrapper {\n    padding: 1rem; /* Adjust this to avoid alignment issues */\n    width: calc(100% - 2rem); /* Account for padding */\n    margin: 0 auto; /* Center */\n    margin-top: 15px;\n    max-width: 85%;\n  }\n}\n\n/* Form  Wrapper */\n.form-wrapper {\n  background-color: #f1f1f1;\n  border-radius: 25px;\n  padding: 20px;\n  margin: 2rem auto;\n  width: 90%;\n  max-width: 800px;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n/* Optional: Für mobile Ansicht */\n@media (max-width: 768px) {\n  .form-wrapper {\n    background-color: #f1f1f1;\n    border-radius: 25px;\n    padding: 10px;\n    margin: 2rem auto;\n    width: 95%;\n    max-width: 800px;\n    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);\n  }\n}\n\n/* Header  Wrapper */\n.header-wrapper {\n  background-color: #1b7ff6;\n  border-radius: 25px;\n  padding: 2rem;\n  margin: 2rem auto;\n  width: 90%;\n  max-width: 1000px;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.header-wrapper h1 {\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  color: white;\n  margin: 0 auto;\n  text-align: center;\n  font-weight: bold;\n  font-size: 30px;\n}\n\n.header-wrapper p {\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  color: white;\n  margin: 0 auto;\n  text-align: center;\n  font-size: 16px;\n  padding-top: 20px;\n}\n\n.colorful-header p{\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n@media (max-width: 768px) {\n  .colorful-header {\n    padding: 20px;\n    margin: 50px auto;\n  }\n\n  .header-wrapper {\n    margin: 0 auto;\n    width: 85%;\n    padding: 20px;\n  }\n\n  .header-wrapper p {\n    padding-top: 0px;\n  }\n\n  .colorful-header p {\n    width: 85%;\n    margin: 20px auto;\n    text-align: center;\n  }\n\n}\n\n/* Initial Navbar */\n.navbar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  background-color: white;\n  max-width: 1000px;\n  width: 90%;\n  margin: 10px auto;\n  border-radius: 20px;\n  border: 1px solid black;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s, padding 0.3s, box-shadow 0.3s ease;\n  position: relative;\n  z-index: 1000;\n}\n\n\n/* Sticky Navbar (Initially hidden) */\n.sticky-navbar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  background-color: white;\n  width: 100vw; /* Full width */\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Add subtle shadow when scrolled */\n  border: none;\n}\n\n.navbar-stick {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  background-color: white;\n  max-width: 1000px;\n  width: 90%;\n  margin: 10px auto;\n  border: none;\n  box-shadow: none;\n  transition: background-color 0.3s, padding 0.3s, box-shadow 0.3s ease;\n  position: relative;\n  z-index: 1000;\n}\n\n@media (max-width: 768px) {\n  .navbar {\n    display: none;\n  }\n  .sticky-navbar {\n    display: none;\n  }\n}\n\n\n/* Navbar Container */\n.navbar-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  width: 95%;\n  margin: 0 auto;\n}\n\n/* Logo Styling */\n.navbar-logo img {\n  height: 40px;\n  display: block;\n}\n\n/* Navbar Links */\n.navbar-links {\n  list-style: none;\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n  font-weight: bold;\n  padding: 0;\n}\n\n.navbar-links a {\n  text-decoration: none;\n  color: black;\n  transition: color 0.3s;\n}\n\n.navbar-links a:hover {\n  color: #1b7ff6;\n  text-decoration: underline;\n}\n\n/* Button Styling */\n.navbar-btn {\n  background-color: #1b7ff6;\n  color: white;\n  padding: 15px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 15px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-btn:hover {\n  transform: scale(1.1);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Mobile Navbar */\n.mobile-navbar {\n  display: none; /* Initially hidden */\n  background-color: white;\n  padding: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  position: relative;\n  z-index: 1100; /* Ensure it appears above other content */\n  border-radius: 20px;\n  border: 1px solid black;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Navbar Header */\n.mobile-navbar-header {\n  display: flex;\n  justify-content: space-between; /* Ensures logo stays left and toggle moves to the right */\n  align-items: center; /* Vertical centering */\n  height: 60px; /* Consistent height for the header */\n  width: 100%; /* Full width */\n}\n\n.mobile-navbar-toggle {\n  color: #1b7ff6; /* Icon color */\n  background: none; /* Transparent background */\n  border: none; /* No border */\n  font-size: 2rem; /* Size of the icon */\n  cursor: pointer; /* Make it clickable */\n  display: flex; /* Flexbox for alignment */\n  align-items: center; /* Center vertically */\n  justify-content: flex-end; /* Align the icon to the right */\n  height: 100%; /* Match parent's height for alignment */\n  width: auto; /* Adjust width to fit the content */\n  margin-left: auto; /* Push the toggle to the far right */\n  padding: 0; /* Remove extra padding for precise alignment */\n}\n\n.mobile-navbar-toggle svg {\n  display: block; /* Ensure it behaves as a block element */\n  margin: 0; /* Remove any default margins */\n  width: 2rem; /* Set an appropriate size for the SVG */\n  height: 2rem; /* Set an appropriate size for the SVG */\n}\n\n/* Mobile Navbar Overlay */\n.mobile-navbar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: white;\n  display: flex;\n  flex-direction: column; /* Stack links vertically */\n  align-items: center;\n  justify-content: center; /* Center the content */\n  z-index: 1200; /* Ensure it overlays all other elements */\n  padding: 2rem;\n  box-sizing: border-box; /* Include padding and borders in width/height */\n}\n\n/* Navbar Links */\n.mobile-navbar-links {\n  list-style: none;\n  display: flex;\n  flex-direction: column; /* Stack links vertically */\n  gap: 1rem; /* Add spacing between links */\n  align-items: center;\n  padding: 0;\n}\n\n.mobile-navbar-links a {\n  text-decoration: none; /* Remove underline */\n  color: black; /* Link color */\n  font-size: 1.5rem; /* Font size */\n  font-weight: bold; /* Bold text */\n}\n\n/* Call-to-action Button */\n.mobile-navbar-btn {\n  background-color: #1b7ff6;\n  color: white;\n  padding: 15px 30px; /* Size of the button */\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: bold; /* Bold text */\n  font-size: 1rem; /* Font size */\n  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth hover effect */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  margin-top: 2rem;\n}\n\n.mobile-navbar-btn:hover {\n  transform: scale(1.1); /* Slightly enlarge on hover */\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* Stronger shadow on hover */\n}\n\n/* Close Icon */\n.mobile-navbar-close {\n  color: #1b7ff6;\n  position: absolute; /* Position relative to the overlay */\n  top: 40px; /* Offset from the top */\n  right: 20px; /* Offset from the right */\n  background: none; /* Transparent background */\n  border: none; /* No border */\n  font-size: 2rem; /* Size of the icon */\n  cursor: pointer; /* Make it clickable */\n}\n\n/* Responsive Rules */\n@media (max-width: 768px) {\n  .navbar-wrapper,\n  .sticky-navbar {\n    display: none;\n  }\n\n  .mobile-navbar {\n    display: block;\n  }\n}\n\n/* Hero Section */\n.hero {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  margin: 0 auto;\n  max-width: 950px;\n  width: 100%;\n}\n\n.hero-content {\n  position: relative;\n  height: auto;\n  text-align: left;\n  padding: 20px;\n  max-width: 50%;\n}\n\n.hero-content h1 {\n  font-size: 40px;\n  font-weight: bolder;\n}\n\n.hero-img {\n  max-width: 50%;\n}\n\n.underline {\n  text-decoration: underline;\n  text-decoration-color: #1b7ff6;\n  text-decoration-thickness: 3px;\n  color: black;\n}\n\n/* Vertical Carousel */\n.v-carousel-mask {\n  height: 50px; /* Match this height to itemHeight in JS */\n  overflow: hidden;\n  display: inline-block;\n  vertical-align: bottom;\n}\n\n.carousel-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.carousel-item {\n  height: 50px; /* Match this height to itemHeight in JS */\n  line-height: 50px; /* Vertically center text */\n  font-size: 24px;\n  text-align: left;\n}\n\n.hero-content span {\n  height: 50px; /* Match this height to itemHeight in JS */\n  line-height: 50px; /* Vertically center text */\n  font-size: 24px;\n  text-align: left;\n}\n\n/* Hide hero image on screens smaller than 768px */\n@media (max-width: 768px) {\n  .hero {\n    display: flex;\n    flex-direction: column; /* Stack content vertically */\n    justify-content: center; /* Center items vertically */\n    align-items: center; /* Center items horizontally */\n    padding: 0;\n    margin: 0 auto;\n    width: 100%; /* Full width for the container */\n    overflow: hidden; /* Prevent content overflow */\n  }\n\n  .hero-content {\n    max-width: 100%;\n    text-align: left; /* Center-align the text */\n  }\n\n  .hero-img {\n    width: auto; /* Allow free width adjustment */\n    max-width: 100%; /* Prevent image from overflowing its container */\n    height: auto; /* Maintain aspect ratio */\n    display: block; /* Ensure the image behaves properly in the layout */\n    margin: 0; /* Remove any default margins */\n    align-self: center; /* Ensure alignment within the flexbox container */\n  }\n\n  .hero-img img {\n    width: 70%;\n    display: block;\n    margin: 0 auto;\n    align-self: center;\n  }\n\n  .hero-content h1 {\n    font-size: 28px; /* Adjust font-size for smaller screens */\n  }\n\n  .carousel-item {\n    height: 50px; /* Match this height to itemHeight in JS */\n    line-height: 50px; /* Vertically center text */\n    font-size: 20px;\n    text-align: left;\n  }\n  \n  .hero-content span {\n    height: 50px; /* Match this height to itemHeight in JS */\n    line-height: 50px; /* Vertically center text */\n    font-size: 20px;\n    text-align: left;\n  }\n}\n\n\n/* Management Hero */\n.management-hero {\n  display: flex; /* Flexbox Layout */\n  flex-direction: column; /* Stapelt die Elemente übereinander */\n  justify-content: flex-start; /* Inhalte oben starten lassen */\n  align-items: center; /* Zentriert die Inhalte horizontal */\n  padding: 2rem;\n  margin: 40px auto;\n  margin-bottom: 0px;\n  max-width: 1000px; /* Maximale Breite der Hero-Section */\n  width: 100%;\n  height: auto; /* Füllt die volle Höhe des Viewports */\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  text-align: center; /* Zentriert den Text */\n}\n\n.management-hero-content {\n  margin-bottom: 2rem; /* Abstand zwischen Text und Bild */\n  max-width: 90%;\n}\n\n.management-hero h1 {\n  font-size: 40px;\n}\n\n.management-hero p {\n  font-size: 18px;\n  max-width: 70%;\n  margin: 0 auto;\n}\n\n.hero-gif img {\n  min-height: 150px;\n  max-height: 350px;\n  width: 100%;\n  margin-bottom: 0;\n}\n\n\n/* Lead Form */\n.lead-form {\n  padding: 1rem;\n  max-width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center; /* Zentriere den Inhalt horizontal */\n  flex-wrap: wrap; /* Umbrüche bei kleineren Bildschirmen */\n  gap: 1rem; /* Abstand zwischen den Input-Feldern */\n}\n\n.lead-form .form-row {\n  display: flex; /* Flexbox für die horizontale Anordnung */\n  flex-wrap: wrap; /* Umbrüche bei kleineren Bildschirmen */\n  gap: 0.5rem; /* Abstand zwischen den Feldern */\n}\n\n.lead-form input,\n.lead-form select {\n  flex: 1; /* Füllt den verfügbaren Platz */\n  min-width: 120px; /* Minimale Breite der Eingabefelder */\n  max-width: 200px; /* Maximale Breite der Eingabefelder */\n  padding: 1rem; /* Erhöhtes Padding für bessere Sichtbarkeit */\n  font-size: 14px; /* Größere Schriftgröße für bessere Lesbarkeit */\n  border: 1px solid black; /* Standardrahmen für Inputs */\n  border-radius: 10px; /* Abgerundete Ecken für Inputs */\n  text-align: center; /* Zentriert den Text im Input-Feld */\n}\n\n.lead-form input::placeholder,\n.lead-form select {\n  text-align: center; /* Zentriert den Platzhaltertext */\n}\n\n.lead-form button {\n  background-color: #007BFF;\n  color: white;\n  padding: 1rem; /* Erhöhtes Padding für den Button */\n  border: none;\n  cursor: pointer;\n  border-radius: 10px; /* Abgerundete Ecken für den Button */\n  flex: 1; /* Gleiche Breite wie die Input-Felder */\n  min-width: 120px; /* Minimale Breite für den Button */\n  max-width: 200px; /* Maximale Breite für den Button */\n  font-size: 14px; /* Größere Schriftgröße für den Button */\n  text-align: center; /* Zentriert den Text im Button */\n  font-weight: bold;\n  transition: transform 0.3s ease;\n}\n\n.lead-form button:hover {\n  transform: scale(1.1);\n  animation: pulse 1s infinite; /* A continuous pulse on hover */\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.lead-form small {\n  margin: 0 auto;\n  text-align: center;\n  max-width: 650px;\n}\n\n@media (max-width: 768px) {\n  .lead-form button {\n    align-self: center;\n  }\n\n}\n\n/* FAQ */\n.faq {\n  padding: 20px;\n  background-color: none;\n}\n\n.faq-wrapper {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.question-faq {\n  border: 1px solid #1b7ff6;\n  padding: 20px;\n  margin-bottom: 15px;\n  border-radius: 10px;\n  padding-bottom: 10px;\n  background-color: white;\n\n}\n\n.faq-arrow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.arrow-faq-right {\n  display: inline-block; /* sorgt dafür, dass die Transformation funktioniert */\n  margin-left: 10px; /* Abstand zwischen Frage und Pfeil */\n}\n\n.faq-heading {\n  font-size: 40px;\n  margin-bottom: 20px;\n  color: white;\n}\n\n.faq-question-heading {\n  font-size: 20px;\n  margin: 0;\n  flex-grow: 1; /* Füge diese Zeile hinzu */\n  margin-right: 10px; /* Optional: Abstand zwischen Frage und Pfeil */\n}\n\n.faq-city-title p {\n  color: white;\n}\n\n.faq-wrapper-text {\n  margin-top: 10px; /* Abstand oben zur Antwort */\n  padding-left: 0px; /* Abstand links zur Antwort */\n  overflow: hidden; /* Verhindert, dass der Inhalt sichtbar ist, während er animiert */\n  background-color: white;\n}\n\n/* Antwortbereich */\n.faq-answer {\n  padding: 0px;\n  background-color: #fff;\n}\n\n@media (max-width: 768px) {\n  .faq-heading {\n    font-size: 28px;\n    margin-bottom: 20px;\n    color: white;\n  }\n  .faq-city-title p {\n    font-size: 15px;\n  }\n  .faq-question-heading {\n    font-size: 15px;\n  }\n  .faq-answer {\n    font-size: 14px;\n  }\n  .how-it-works-image {\n    min-width: 250px;\n  }\n}\n\n\n/* Footer Styling */\n.footer {\n  background-color: none; /* Weißer Hintergrund */\n  color: black; /* Schwarzer Text */\n  padding: 2rem; /* Innenabstand */\n  font-family: 'Plus Jakarta Sans', sans-serif; /* Schriftart */\n  max-width: 1000px; /* Maximale Breite */\n  margin: 0 auto; /* Zentriert den Footer */\n}\n\n@media (max-width: 768px) {\n  .footer {\n    display: none;\n  }\n}\n\n.footer-container {\n  display: flex; /* Flexbox für Layout */\n  justify-content: space-between; /* Platz zwischen Sektoren */\n  align-items: flex-start; /* Sektoren oben ausrichten */\n}\n\n.footer-logo img {\n  height: 60px; /* Logo-Höhe */\n}\n\n.footer-links {\n  display: flex; /* Flexbox für Links */\n  gap: 2rem; /* Abstand zwischen den Spalten */\n}\n\n.footer-column {\n  display: flex; /* Flexbox für Spalten */\n  flex-direction: column; /* Spalten vertikal anordnen */\n}\n\n.footer-column h4 {\n  margin-bottom: 0.5rem; /* Abstand unter den Überschriften */\n}\n\n.footer-column ul {\n  list-style: none; /* Keine Aufzählungszeichen */\n  padding: 0; /* Kein Padding */\n}\n\n.footer-column li {\n  margin-bottom: 0.5rem; /* Abstand zwischen den Links */\n}\n\n.footer-column a {\n  text-decoration: none; /* Keine Unterstreichung */\n  color: black; /* Schwarze Links */\n  transition: color 0.3s; /* Sanfter Farbwechsel */\n}\n\n.footer-column a:hover {\n  color: #1b7ff6; /* Farbwechsel beim Hover */\n}\n\n.footer-support {\n  width: 100%; /* Volle Breite für den Unterstützungsteil */\n  margin-top: 2rem; /* Abstand über dem Unterstützungsteil */\n  display: flex; /* Flexbox für Spalten */\n  flex-wrap: wrap; /* Wrap, um auf kleinere Bildschirme zu reagieren */\n}\n\n.footer-cities {\n  display: flex; /* Flexbox für Städte */\n  width: 100%; /* Volle Breite für die Städte */\n  justify-content: space-between; /* Platz zwischen den Städten gleichmäßig verteilen */\n  margin-top: 1rem; /* Abstand über dem Text */\n}\n\n.footer-city {\n  flex: 1; /* Flex-Elemente gleichmäßig verteilen */\n  text-align: center; /* Zentriere den Text */\n  margin: 0 1rem; /* Abstand zwischen den Spalten */\n}\n\n.footer-divider {\n  margin: 2rem 0; /* Abstand über und unter dem Strich */\n  border: 0; /* Entferne den Standardrahmen */\n  height: 1px; /* Höhe des Strichs */\n  background-color: #ccc; /* Farbe des Strichs */\n}\n\n.footer-info {\n  text-align: center; /* Text zentrieren */\n  margin-top: 1rem; /* Abstandh oben */\n}\n\n.footer-info a {\n  text-decoration: none;\n  color: black;\n}\n\n@media (max-width: 768px) {\n  .footer-logo img {\n    height: 40px; /* Logo-Höhe */\n  }\n}\n\n/* Mobile Footer */\n/* Mobile Footer */\n.mobile-footer {\n  display: none; /* Hidden by default */\n  background-color: none;\n  color: black;\n  padding: 1rem;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  margin-top: 50px;\n}\n\n@media (max-width: 768px) {\n  .mobile-footer {\n    display: block; /* Only visible on mobile */\n    padding: 30px;\n    padding-top: 0px;\n  }\n}\n\n.mobile-footer-logo {\n  text-align: left; /* Align the logo to the top-left */\n  margin-bottom: 1rem;\n}\n\n.mobile-footer-logo img {\n  height: 50px;\n}\n\n.mobile-footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem; /* Space between sections */\n}\n\n.mobile-footer-column h4 {\n  font-size: 1rem;\n  font-weight: bold;\n  text-decoration: underline;\n  margin-bottom: 0.5rem;\n}\n\n.mobile-footer-column ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.mobile-footer-column li {\n  margin-bottom: 0.5rem;\n}\n\n.mobile-footer-column a {\n  text-decoration: none;\n  color: black;\n  font-size: 0.9rem;\n}\n\n.mobile-footer-column a:hover {\n  color: #1b7ff6;\n}\n\n.mobile-footer-info {\n  margin-top: 1rem;\n  text-align: left;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.mobile-footer-info a {\n  color: black;\n  text-decoration: none;\n}\n\n.mobile-footer-info a:hover {\n  color: #1b7ff6;\n}\n\n/* ThreeColumns Styling */\n\n.three-columns {\n  padding: 2rem;\n  background-color: none; /* Heller Hintergrund */\n  text-align: center;\n  max-width: 1000px;\n  margin:0 auto;\n  margin-top: 100px;\n}\n\n.three-columns-title {\n  margin-bottom: 1.5rem; /* Abstand unter der Überschrift */\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  text-align: center;\n}\n\n.three-columns-small-title {\n  color: #666;\n  text-align: center;\n}\n\n.three-columns-small-title a {\n  color: #1b7ff6;\n}\n\n.three-columns-container {\n  display: flex; /* Flexbox for the columns */\n  justify-content: space-between; /* Space between columns */\n  gap: 1rem;\n}\n\n/* Make the columns stack vertically on screens smaller than 768px */\n@media (max-width: 768px) {\n  .three-columns-container {\n    flex-direction: column; /* Stack columns vertically */\n    align-items: center;\n  }\n\n  .three-columns {\n    margin-top: 50px;\n  }\n  \n  .three-columns-title {\n    font-size: 28px;\n  }\n}\n\n.three-column-image {\n  max-width: 100%; /* Bild responsive */\n  height: auto;\n}\n\n.three-column-subtitle {\n  padding: 10px 20px;\n  border: 1px solid #1b7ff6;\n  border-radius: 10px;\n  background-color: #1b7ff6;\n  color: white;\n}\n\n.three-column-text {\n  margin-top: 0.5rem; /* Abstand über dem Text */\n}\n\n/* ThreeStep Styling */\n.three-step {\n  padding: 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n  margin-top: 80px;\n}\n\n.three-step h1 {\n  text-align: center;\n}\n\n.three-step-small {\n  color: #666;\n  text-align: center;\n}\n\n.three-step-small a {\n  color: #1b7ff6;\n}\n\n.step {\n  display: flex; /* Flex layout for desktop */\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.step-circle {\n  background-color: #1b7ff6;\n  color: white;\n  font-weight: bold;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  margin-right: 1rem;\n}\n\n.step-content {\n  flex: 1;\n}\n\n.step-title {\n  margin-bottom: 0.5rem;\n}\n\n.step-image {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Mobile styling */\n@media (max-width: 768px) {\n  .three-step {\n    margin-top: 50px;\n  }\n  .three-step h1 {\n    font-size: 28px;\n  }\n  .step {\n    display: flex;\n    align-items: center;\n    flex-direction: row; /* Align circle and content horizontally */\n    justify-content: flex-start;\n  }\n\n  .step-circle {\n    display: none;\n  }\n\n  .step-content {\n    text-align: center; /* Align text to the left on mobile */\n    border: 1px solid grey;\n    border-radius: 15px;\n  }\n\n  .step img {\n    display: none; /* Hide images mobile */\n  }\n}\n\n/* White Button */\n.button-white-container {\n  display: flex;\n  justify-content: center; /* Zentriert den Button horizontal */\n  margin: 2rem 0; /* Abstand oben und unten */\n}\n\n.custom-white-button {\n  background-color: #f1f1f1;\n  color: black;\n  padding: 20px; /* Erhöhtes Padding für den Button */\n  border: none;\n  cursor: pointer;\n  border-radius: 10px; /* Abgerundete Ecken für den Button */\n  min-width: 120px; /* Minimale Breite für den Button */\n  max-width: 300px; /* Maximale Breite für den Button */\n  font-size: 16px; /* Größere Schriftgröße für den Button */\n  text-align: center; /* Zentriert den Text im Button */\n  font-weight: bold;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Normal shadow */\n}\n\n.custom-white-button:hover {\n  transform: scale(1.1);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* Shadow becomes more intense */\n}\n\n\n/* Blue Button */\n.button-blue-container {\n  display: flex;\n  justify-content: center; /* Zentriert den Button horizontal */\n  margin: 0; /* Abstand oben und unten */\n}\n\n.custom-blue-button {\n  background-color: #1b7ff6;\n  color: white;\n  padding: 20px; /* Erhöhtes Padding für den Button */\n  border: none;\n  cursor: pointer;\n  border-radius: 10px; /* Abgerundete Ecken für den Button */\n  min-width: 120px; /* Minimale Breite für den Button */\n  max-width: 300px; /* Maximale Breite für den Button */\n  font-size: 16px; /* Größere Schriftgröße für den Button */\n  text-align: center; /* Zentriert den Text im Button */\n  font-weight: bold;\n  margin-bottom: 40px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Normal shadow */\n}\n\n.custom-blue-button:hover {\n  transform: scale(1.1);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* Shadow becomes more intense */\n}\n\n\n/* Gesamtformular-Wrapper */\n.form {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 500px; /* Definiere eine Mindesthöhe für das gesamte Formular */\n  height: 100%; /* Damit sich das Formular dynamisch an die Höhe anpasst */\n}\n\n/* Fortschrittsanzeige (Progress Bar) */\n.progress-bar-wrapper {\n  width: 100%;\n  background-color: #e0e0e0;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.progress-bar {\n  height: 30px;\n  background-color: #1b7ff6;\n  border-radius: 10px;\n  text-align: center;\n  color: white;\n  font-weight: bold;\n  transition: width 0.3s ease;\n}\n\n\n/* Container für den dynamischen Inhalt (Schritte) */\n.form-container {\n  background-color: none;\n  padding: 0px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start; /* Inhalt oben ausrichten */\n  min-height: 300px;\n  max-height: 300px; /* Setze eine Maximalhöhe, um eine konstante Höhe zu gewährleisten */\n  box-sizing: border-box; /* Verhindert, dass Padding die Höhe beeinflusst */\n}\n\n/* Zentriert die Überschrift im Formular */\n.form h2 {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n/* Überschrift der einzelnen Schritte oben ausrichten */\n.form-container h3 {\n  margin-top: 0; /* Keine zusätzliche Oberkante */\n  margin-bottom: 20px; /* Konsistenter Abstand nach unten */\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n/* Button-Container mit einem Button (unten rechts) */\n.hv-button-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0px;\n}\n\n/* Spezielle Klasse für den Button-Container im ersten Schritt */\n.single-button-container {\n  justify-content: flex-end;\n}\n\n/* Wenn zwei Buttons da sind (Zurück und Weiter) */\n.hv-two-button-container {\n  justify-content: space-between;\n}\n\n.hv-next-button,\n.hv-back-button {\n  padding: 12px; /* Feste Höhe durch gleichmäßiges Padding */\n  min-height: 40px; /* Mindesthöhe für alle Buttons */\n  min-width: 100px;\n  font-size: 14px;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n  text-align: center;\n}\n\n.hv-radio-container,\n.hv-radio,\n.hv-input-container,\n.hv-input {\n  box-sizing: border-box;\n}\n\n.hv-input-container {\n  gap: 10px;\n}\n\n/* Remove spinner controls from number input */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield; /* For Firefox */\n}\n\n/* Style für den \"Weiter\"-Button */\n.hv-next-button {\n  background-color: #1b7ff6;\n  color: white;\n  padding: 10px;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n  min-width: 100px;\n  height: auto;\n  font-size: 14px;\n  text-align: center;\n  font-weight: bold;\n}\n\n/* Style für den \"Zurück\"-Button */\n.hv-back-button {\n  background-color: transparent;\n  color: #1b7ff6;\n  border: 2px solid #1b7ff6;\n  padding: 10px;\n  cursor: pointer;\n  border-radius: 5px;\n  min-width: 100px;\n  font-size: 14px;\n  text-align: center;\n  font-weight: bold;\n}\n\n/* Datenschutz-Text */\nsmall {\n  margin-top: 20px;\n  display: block;\n  text-align: center;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\nsmall a {\n  color: #1b7ff6;\n  text-decoration: none;\n}\n\n.hv-radio-container {\n  display: flex;                   \n  flex-direction: column;          \n  width: 100%;      \n  align-items: center;          \n}\n\n.hv-radio {\n  display: flex;                   \n  align-items: center;             \n  margin-bottom: 10px;            \n  width: 100%;                    \n  padding: 12px;                  \n  border: 1px solid #1b7ff6;     \n  border-radius: 10px;            \n  background-color: transparent;     \n  font-size: 14px;                \n  cursor: pointer;                \n  transition: background-color 0.3s; \n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.hv-radio:hover {\n  background-color: #1b7ff6;      /* Hintergrundfarbe beim Hover */\n  color: white;\n  font-size: bold;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.hv-radio input {\n  margin-right: 10px;             /* Abstand zwischen Radio-Button und Label-Text */\n}\n\n/* Styling the checked radio input + adjacent .hv-radio */\n.hv-radio.checked {\n  background-color: #1b7ff6;\n  color: white;\n}\n\n/* Modernes Styling für das Dropdown-Menü */\n.hv-select-wrapper {\n  position: relative;\n  width: 100%;\n  display: flex;\n}\n\n.hv-select-wrapper::after {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.hv-select {\n  flex: 1; /* Füllt den verfügbaren Platz im Wrapper */\n  padding: 12px;\n  font-size: 14px;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  border-radius: 10px;\n  background-color: transparent;\n  color: black;\n  border: 1px solid #1b7ff6;\n  appearance: none; /* Entfernt den Standard-Stil */\n  cursor: pointer;\n  transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out; /* Smooth ease-out animation */        \n}\n\n\n/* Styling für die Input-Felder (Schritt 3 und 5) */\n.hv-input-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Zentriert die Inhalte horizontal */\n}\n\n.hv-input {\n  width: 100%;\n  padding: 12px;\n  font-size: 14px;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  border-radius: 10px;\n  background-color: transparent;\n  color: black;\n  border: 1px solid #1b7ff6;\n  appearance: none; /* Entfernt den Standard-Stil */\n  cursor: pointer;\n  transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out; /* Smooth ease-out animation */\n  align-items: center;    \n}\n\n.hv-input:focus {\n  border-color: #0056b3; /* Dunklerer Blauton beim Fokussieren */\n  outline: none;\n}\n\n.hv-input::placeholder {\n  color: #aaa; /* Graue Platzhalterfarbe */\n  font-style: none;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n\n/* Form Schritt 6 */\n.hv-input-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* 2 Spalten */\n  gap: 10px; /* Abstand zwischen den Feldern */\n}\n\n.hv-input-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.hv-input-multi {\n  width: auto;\n  padding: 12px;\n  font-size: 14px;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  border-radius: 10px;\n  background-color: transparent;\n  color: black;\n  border: 1px solid #1b7ff6;\n  appearance: none; /* Entfernt den Standard-Stil */\n  cursor: pointer;\n  transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out; /* Smooth ease-out animation */\n  align-items: center;    \n}\n\n.hv-input-multi::placeholder {\n  color: #aaa; /* Graue Platzhalterfarbe */\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n@media (max-width: 768px) {\n  .hv-input-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%; /* Ensure the container doesn't overflow */\n    box-sizing: border-box; /* Includes padding and borders in the width */\n  }\n\n  .hv-input-group {\n    width: 100%; /* Ensure each group takes full width */\n    box-sizing: border-box; /* Prevent overflow due to padding */\n  }\n\n  .hv-input-multi {\n    width: 100%; /* Prevent inputs from overflowing */\n    max-width: 100%; /* Ensure inputs stay within their parent */\n    box-sizing: border-box; /* Include padding and borders in the width calculation */\n  }\n\n  /* Optional: Add padding to prevent content from touching screen edges */\n  .form-container {\n    padding: 0 16px; /* Add left/right padding for better mobile UX */\n  }\n}\n\n/* Form Header */\n\n.form-header {\n  display: flex;\n  justify-content: center; \n  align-items: center; \n  height: auto; \n  background-color: none;\n  text-align: center; \n  padding: 0px;\n  margin-top: 0px;\n}\n\n.header-content {\n  max-width: 450px;\n}\n\n.header-content small {\n  font-size: 14px; \n  font-family: 'Plus Jakarta Sans', sans-serif;\n  color: white; \n  display: block;\n  margin-bottom: 10px;\n}\n\n.header-content h1 {\n  font-size: 32px; \n  font-family: 'Plus Jakarta Sans', sans-serif;\n  color: white; \n  margin-bottom: 15px;\n}\n\n.header-content p {\n  font-size: 18px; /* Mittlere Schriftgröße für den Beschreibungstext */\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  color: white; /* Leicht abgedunkelte Farbe */\n  margin-bottom: -5px;\n}\n\n@media (max-width: 768px) {\n  .header-content h1 {\n    font-size: 28px; \n    font-family: 'Plus Jakarta Sans', sans-serif;\n    color: white; \n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n\n  .header-content p {\n    font-size: 16px; /* Mittlere Schriftgröße für den Beschreibungstext */\n    font-family: 'Plus Jakarta Sans', sans-serif;\n    color: white; /* Leicht abgedunkelte Farbe */\n    margin-bottom: -5px;\n  }\n\n}\n\n/* Impressum */\n.impressum-container {\n  max-width: 1000px;\n  width: 90%;\n  margin: 40px auto;\n}\n\n@media (max-width: 768px) {\n  .impressum-container h1 {\n    font-size: 28px;\n  }\n}\n\n\n\n/* Blog Styling*/\n.blog-overview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 10px;\n  margin: 0 auto;\n  max-width: 1200px;\n  justify-content: center;\n  align-items: stretch; /* Ensures all cards have the same height */\n  margin-top: 60px;\n}\n\n.blog-card {\n  width: 30%;\n  max-width: 350px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  height: 100%; /* Ensures the card takes up full height */\n  min-height: 380px;\n}\n\n.blog-card a {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1; /* Ensures the link content grows */\n  text-decoration: none;\n  color: inherit;\n}\n\n.blog-card h2 {\n  font-size: 22px;\n}\n\n.blog-card-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.blog-card-content {\n  padding: 15px;\n  flex-grow: 1; /* Make the content take up remaining space */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.blog-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; /* Vertikales Zentrieren */\n  font-size: 0.9rem;\n  color: #666;\n  margin-top: auto; /* Damit das gesamte meta unten ist */\n}\n\n.blog-date {\n  display: flex;\n  align-items: center; /* Stellt sicher, dass der Inhalt auch im Span vertikal zentriert ist */\n}\n\n/* Category styles */\n.blog-category {\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.blog-category.category-news {\n  background-color: #ff6b6b; /* Red for news */\n}\n\n.blog-category.category-vermietung {\n  background-color: #4ecdc4; /* Turquoise for vermietung */\n}\n\n.blog-category.category-verwaltung {\n  background-color: #1a73e8; /* Blue for verwaltung */\n}\n\n.load-more-btn {\n  background-color: #1b7ff6;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  font-weight: bold;\n  font-size: 14px;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin: 20px auto;\n  display: block;\n}\n\n.load-more-btn:hover {\n  background-color: #1b7ff6;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.blog-wrapper {\n  position: relative;\n  padding: 20px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.category-filter {\n  position: absolute;\n  display: flex;\n  gap: 5px;\n  padding: 5px;\n}\n\n/* Common button styling */\n.category-btn {\n  background-color: #f0f0f0;\n  color: black;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n/* Active button styling */\n.category-btn.active {\n  background-color: #1b7ff6;\n  color: white;\n}\n\n/* Hover effect */\n.category-btn:hover {\n  background-color: #1b7ff6;\n  color: white;\n}\n\n/* Custom styling for each category */\n.category-btn-news:hover,\n.category-btn-news.active {\n  background-color: #ff6b6b; /* Red for news */\n  color: white;\n}\n.category-btn-vermietung:hover,\n.category-btn-vermietung.active {\n  background-color: #4ecdc4; /* Turquoise for vermietung */\n  color: white;\n}\n\n.category-btn-verwaltung:hover,\n.category-btn-verwaltung.active {\n  background-color: #1a73e8; /* Blue for verwaltung */\n  color: white;\n}\n\n/* Ensure active buttons retain their color when selected */\n.category-btn-news.active,\n.category-btn-vermietung.active,\n.category-btn-verwaltung.active {\n  color: white;\n}\n/* Author styling */\n.blog-author {\n  display: flex;\n  align-items: center;\n  padding: 20px;\n}\n\n.author-image {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 15px;\n}\n\n.blog-detail {\n  padding: 40px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.blog-main-image {\n  width: 100%;\n  height: 400px;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.blog-content {\n  padding: 20px;\n}\n\n.blog-body {\n  font-size: 1.1rem;\n  line-height: 1.6;\n}\n\n.blog-body img {\n  display: block;\n  margin: 0 auto; /* Centers the image horizontally */\n  max-width: 100%; /* Makes the image responsive */\n  height: auto; /* Maintains aspect ratio */\n}\n\n\n@media (max-width: 768px) {\n  .blog-wrapper {\n    padding: 0px;\n    margin-top: 0px;\n  }\n  \n  .category-filter {\n    margin-top: 0px;\n    display: none;\n  }\n\n  .blog-overview {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    padding: 5px;\n    margin: 0 auto;\n    max-width: 1200px;\n    justify-content: center;\n    align-items: stretch; /* Ensures all cards have the same height */\n    margin-top: 50px;\n  }\n  \n  .blog-card {\n    width: 80%;\n    max-width: 350px;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    height: 100%; /* Ensures the card takes up full height */\n    min-height: 100%;\n  }\n\n  .blog-card a {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1; /* Ensures the link content grows */\n    text-decoration: none;\n    color: inherit;\n  }\n  \n  .blog-card h2 {\n    font-size: 20px;\n    text-align: center;\n  }\n  \n  .blog-card-image {\n    width: 100%;\n    height: 150px;\n    object-fit: cover;\n  }\n  \n  .blog-card-content {\n    padding: 15px;\n    flex-grow: unset; /* Remove the flex-grow behavior */\n    display: block; /* Remove column flex behavior */\n  }\n  \n  .blog-meta {\n    gap: 5px; /* Add a small gap between category and date */\n    justify-content: space-between; /* Center the content */\n    margin-top: 0; /* Remove extra margin */\n    }\n  \n  .blog-date {\n    display: flex;\n    align-items: center; /* Stellt sicher, dass der Inhalt auch im Span vertikal zentriert ist */\n  }\n  \n  .blog-detail {\n    padding: 10px;\n  }\n\n  .blog-body {\n    font-size: 16px;\n  }\n}\n\n\n/* Mission Section */\n.mission {\n  display: flex; /* Flexbox Layout für die horizontale Anordnung von Text und Bild */\n  justify-content: space-between; /* Text und Bild werden aufgeteilt */\n  align-items: center; /* Vertikale Zentrierung */\n  padding: 40px; /* Padding für die gesamte Sektion */\n  margin: 0 auto;\n  max-width: 850px; /* Maximale Breite der Sektion */\n  width: 100%; /* Volle Breite */\n  margin-top: 60px;\n}\n\n.mission-content {\n  max-width: 66%; /* Maximalbreite für den Textbereich */\n}\n\n.mission-small-text {\n  font-size: 14px; /* Kleinere Schrift für den Mission-Text */\n  color: #1b7ff6; /* Optional: Farbe für den kleinen Text */\n  text-transform: uppercase; /* Optional: Alles groß schreiben */\n  margin-bottom: 0.5rem;\n}\n\n.mission-heading {\n  font-size: 30px; /* Große Schrift für H1 */\n  font-weight: bold;\n  margin-bottom: 1rem;\n}\n\n.mission-content a{\n  color: #1b7ff6;\n}\n\n.mission-content h3 {\n  color: #666;\n}\n\n.mission-paragraph {\n  font-size: 18px; /* Normaler Schriftgröße für den Paragraphen */\n  line-height: 1.6; /* Zeilenhöhe für bessere Lesbarkeit */\n}\n\n.mission-image img {\n  max-width: 100%; /* Bild passt sich der Breite des Containers an */\n  height: auto; /* Proportionales Skalieren des Bildes */\n  margin-left: 2rem; /* Abstand zwischen Text und Bild */\n  border-radius: 8px; /* Optional: abgerundete Ecken beim Bild */\n}\n\n/* Mobile Styling */\n/* Mission Section - Mobile Fix */\n@media (max-width: 768px) {\n  .mission {\n    display: flex;\n    flex-direction: column; /* Stack content vertically */\n    align-items: center; /* Center-align all content horizontally */\n    justify-content: center; /* Center-align vertically */\n    padding: 20px; /* Adjust padding */\n    margin: 0 auto; /* Center the section */\n    margin-top: 50px;\n    width: 100%; /* Ensure full width */\n    max-width: 100%; /* Prevent overflow */\n    box-sizing: border-box; /* Include padding and border in width */\n    text-align: center; /* Center-align text */\n    overflow-x: hidden; /* Prevent horizontal scrolling */\n  }\n\n  .mission-content {\n    max-width: 90%; /* Limit the width of text content */\n    margin: 0 auto; /* Center-align the text block */\n  }\n\n  .mission-heading {\n    font-size: 28px; /* Adjust font size for headings */\n    margin-bottom: 10px; /* Add space below the heading */\n  }\n\n  .mission-content h3 {\n    font-size: 18px;\n  }\n\n  .mission-paragraph {\n    font-size: 16px; /* Adjust font size for readability */\n    line-height: 1.6; /* Improve line spacing */\n    margin-bottom: 20px; /* Add space below the paragraph */\n  }\n\n  .mission-image img {\n    width: 70%; /* Restrict image width */\n    max-width: 300px; /* Prevent images from being too large */\n    height: auto; /* Maintain aspect ratio */\n    margin: 0 auto; /* Center the image */\n    display: block; /* Ensure proper image rendering */\n  }\n}\n\n/* Change Section */\n.change-section {\n  padding: 3rem 2rem; /* Padding um die gesamte Sektion */\n  max-width: 1200px;\n  margin: 0 auto;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.change-header {\n  text-align: center; /* Zentriert den Header */\n  margin-bottom: 3rem; /* Abstand zwischen Header und den Schritten */\n}\n\n.change-small-text {\n  color: #666;\n  margin-bottom: 0.5rem;\n}\n\n.change-small-text a {\n  color: #1b7ff6;\n}\n\n.change-heading {\n  font-size: 36px;\n  font-weight: bold;\n  margin-bottom: 1rem;\n}\n\n.change-paragraph {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #555; /* Optional: Etwas hellere Textfarbe für bessere Lesbarkeit */\n  max-width: 600px;\n  margin: 0 auto;\n  margin-top: 20px;\n}\n\n/* Change Steps */\n.change-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem; /* Abstand zwischen den Schritten */\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.change-step {\n  display: flex;\n  align-items: center;\n  gap: 2rem; /* Abstand zwischen Bild und Text */\n  margin-right: 0;\n}\n\n.change-step img {\n  width: 80px; /* Festgelegte Breite des Bildes */\n  height: auto;\n  align-self: left;\n}\n\n.change-step-content {\n  max-width: auto; /* Maximale Breite für den Textbereich des Schritts */\n}\n\n.step-small-text {\n  font-size: 14px;\n  color: #1b7ff6;\n  margin-bottom: 0.5rem;\n}\n\n.step-paragraph {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #555;\n  margin-bottom: 0px;\n}\n\n.step-paragraph a {\n  color: #1b7ff6;\n}\n\n/* Optional: Für mobile Ansicht */\n@media (max-width: 768px) {\n  .change-section {\n    padding: 15px;\n    margin-bottom: 50px;\n  }\n\n  .change-heading {\n    font-size: 28px;\n  }\n\n  .change-small-text {\n   font-size: 18px;\n  }\n\n  .step-paragraph {\n    font-size: 14px;\n  }\n\n  .change-step img {\n    width: 20%;\n    max-width: 300px; /* Maximale Breite für Bilder in der mobilen Ansicht */\n  }\n  .change-step-content {\n    max-width: 100%;\n  }\n}\n\n\n\n/* Container für die Vorteile */\n.advantages-container {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 20px;\n  background-color: none; /* Optionaler Hintergrund */\n  border-radius: 10px; /* Abgerundete Ecken für das Container */\n  max-width: 80%;\n  margin: 0 auto;\n}\n\n/* Einzelnes Vorteil-Element */\n.advantage-item {\n  display: flex;\n  align-items: center;\n  background-color: #f1f1f1;\n  padding: 20px;\n  border-radius: 10px;\n  width: 32%; /* Nimmt 32% der Breite für drei gleich große Boxen nebeneinander */\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Bild des Vorteils */\n.advantage-image {\n  margin-right: 15px;\n}\n\n.image-icon {\n  width: 60px; /* Größe des Icons */\n  height: auto;\n}\n\n/* Inhalt (Titel und Beschreibung) */\n.advantage-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.advantage-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1b305f; /* Dunkleres Blau für die Titel */\n  margin-bottom: 5px;\n\n}\n\n.advantage-description {\n  font-size: 14px;\n  color: #4a4a4a; /* Leicht graue Textfarbe für den Fließtext */\n  max-width: 100%;\n}\n\n/* Anpassungen für kleinere Bildschirme */\n@media (max-width: 768px) {\n  .advantages-container {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .advantage-item {\n    width: 100%; /* Volle Breite für mobile Ansicht */\n  }\n}\n\n/* Why Styling */\n.why-section {\n  display: flex;\n  justify-content: space-between;\n  padding: 50px 80px;\n}\n\n.why-content {\n  display: flex;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.why-intro {\n  width: 50%;\n  padding: 20px;\n  align-self: center;\n}\n\n.why-intro h3 {\n  color: #666;\n  text-align: center;\n}\n\n.why-intro a {\n  color: #1b7ff6;\n}\n\n.small-text {\n  color: #1b7ff6;\n  font-size: 14px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.why-title {\n  font-size: 30px;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  color: #1A1A1A;\n  margin-top: 10px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.why-description {\n  font-size: 16px;\n  color: #666;\n  margin-top: 20px;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.why-button {\n  background-color: #E94235;\n  color: white;\n  padding: 15px 25px;\n  border: none;\n  font-size: 16px;\n  margin-top: 30px;\n  cursor: pointer;\n}\n\n.why-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  width: 50%;\n  padding: 20px;\n}\n\n.why-step {\n  display: flex;\n  align-items: center;\n}\n\n.step-icon {\n  margin: 0 auto;\n}\n\n.step-icon img {\n  min-width: 60px;\n}\n\n.step-content {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n}\n\n.step-number {\n  color: #1b7ff6;\n  font-weight: bold;\n  font-size: 14px;\n  text-align: left;\n}\n\n.step-title {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 5px 0;\n}\n\n.step-description {\n  font-size: 16px;\n  color: #666;\n}\n\n@media (max-width: 768px) {\n  .why-section {\n    padding: 10px;\n  }\n\n  .why-step {\n    display: none !important; /* Hides the step completely */\n  }\n\n  .why-steps {\n    display: none; /* Ensures the entire steps container is hidden */\n  }\n\n  .why-intro {\n    width: 100%; /* Ensures full width for intro */\n    margin: 0 auto; /* Centers the intro horizontally */\n    text-align: center; /* Centers text inside the intro */\n    padding: 1rem; /* Optional padding for better spacing */\n  }\n\n  .why-intro h1 {\n    font-size: 1.5rem; /* Adjust font size for mobile */\n  }\n\n  .why-intro p {\n    font-size: 1rem; /* Adjust paragraph size for readability */\n  }\n\n  .custom-blue-button {\n    font-size: 16px;\n  }\n}\n/* Case Overview */\n.section.case-studies {\n  padding: 50px 0;\n}\n\n.container-medium-714px {\n  max-width: 714px;\n  margin: 0 auto;\n}\n\n.case-studies-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.card.case-study {\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.case-study-card-content {\n  padding-top: 20px;\n}\n\n.case-study-company {\n  font-weight: bold;\n}\n\n.case-study-title-link {\n  text-decoration: none;\n  color: #000;\n}\n\n.increased-quantity {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.divider {\n  height: 2px;\n  background-color: #ddd;\n}\n\n/* Case */\n.container-default {\n  max-width: 1000px;\n  padding: 50px;\n  margin: 0 auto;\n}\n\n.case-study-page {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.case-study-company-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.case-study-company-page {\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.case-study-date {\n  color: #666;\n}\n\n.split-content {\n  width: 100%;\n}\n\n.about-case-study-grid {\n  display: flex;\n  gap: 20px;\n}\n\n.about-case-study-wrapper {\n  flex: 1;\n}\n\n.case-study-result-number {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.image-wrapper.case-study-page {\n  margin-top: 20px;\n}\n\n.project-overview-wrapper {\n  margin-top: 50px;\n}\n\n.rich-text {\n  line-height: 1.5;\n}\n\n\n/* About Section */\n.about-section {\n  text-align: center;\n  padding: 50px 20px;\n  background-color: none;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.about-heading h1 {\n  font-size: 2.5rem;\n  color: #202040;\n  margin-bottom: 10px;\n}\n\n.about-heading h2 {\n  color: #666;\n}\n\n.about-heading h2 a{\n  color: #1b7ff6;\n}\n\n.about-team {\n  font-size: 14px; /* Kleinere Schrift für den Mission-Text */\n  color: #1b7ff6; /* Optional: Farbe für den kleinen Text */\n  text-transform: uppercase; /* Optional: Alles groß schreiben */\n  margin-bottom: 0.5rem;\n}\n\n.about-description {\n  font-size: 1rem;\n  color: black;\n  margin-bottom: 40px;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.bubble-wrapper {\n  background-color: white;\n  max-width: 900px;\n  margin: 50px auto;\n  margin-bottom: 0px;\n  border-radius: 25px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center; /* Center content horizontally */\n  gap: 20px; /* Space between items */\n  padding: 20px;\n}\n\n.statistics {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr); /* Default: 4 columns */\n  gap: 20px; /* Space between grid items */\n  width: 100%;\n}\n\n.stat-item {\n  background-color: none;\n  border-radius: 10px;\n  text-align: center;\n  max-width: 200px;\n}\n\n.stat-item h2 {\n  font-size: 2rem;\n  color: #202040;\n  margin-bottom: 0px;\n}\n\n.stat-item h2 span {\n  color: #1b7ff6;\n  font-size: 1.5rem;\n}\n\n.stat-item p {\n  font-size: 1rem;\n  color: #6c757d;\n  margin-bottom: 0px;\n}\n\n@media (max-width: 768px) {\n  .about-heading h1 {\n    font-size: 28px;\n  }\n  .about-heading h2 {\n    font-size: 18px;\n  }\n  .statistics {\n    grid-template-columns: repeat(2, 1fr); /* Mobile: 2 columns */\n  }\n}\n\n\n/* Team */\n.team-section {\n  text-align: center;\n  padding: 50px 20px;\n  background-color: none;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.team-heading {\n  font-size: 14px; /* Kleinere Schrift für den Mission-Text */\n  color: #1b7ff6; /* Optional: Farbe für den kleinen Text */\n  text-transform: uppercase; /* Optional: Alles groß schreiben */\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.team-title {\n  font-size: 2.5rem;\n  color: black;\n}\n\n.team-section h3 {\n  color: #666;\n  margin-bottom: 40px;\n}\n\n.team-section a {\n  color: #1b7ff6;\n}\n\n.team-members {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  flex-wrap: wrap;\n}\n\n.team-member-card {\n  border-radius: 15px;\n  padding: 0px;\n  text-align: center;\n  width: 300px;\n}\n\n.team-member-image {\n  width: 100%;\n  border-radius: 15px;\n  height: 300px;\n  object-fit: cover;\n}\n\n.team-member-name {\n  font-size: 1.2rem;\n  color: #202040;\n  margin-top: 20px;\n}\n\n.team-member-title {\n  color: #6c757d;\n  font-size: 1rem;\n  margin: 10px 0;\n}\n\n.linkedin-icon {\n  color: #0077b5;\n  font-size: 1.5rem;\n  display: inline-block;\n  margin-top: 10px;\n  transition: color 0.3s ease;\n}\n\n.linkedin-icon:hover {\n  color: #005582;\n}\n\n.team-member-card h3 {\n  color: black;\n  margin-bottom: 0px;\n}\n\n@media (max-width: 768px) {\n  .team-section {\n    margin-top: 50px;\n  }\n\n  .team-title {\n    font-size: 28px;\n  }\n\n  .team-section h3 {\n    font-size: 18px;\n  }\n\n  .team-member-image {\n    width: 85%;\n    height: auto ;\n  }\n}\n\n/* Service */\n.services-container {\n  text-align: center;\n  padding: 40px;\n  max-width: 1000px;\n  margin: 0 auto;\n  margin-top: 80px;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.services-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #222;\n  margin-bottom: 10px;\n}\n\n.services-container h3 {\n  color: #666;\n  margin-bottom: 40px;\n}\n\n.services-container a {\n  color: #1b7ff6;\n}\n\n.services-subtitle {\n  font-size: 1rem;\n  color: #666;\n  margin-bottom: 40px;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* Fixed 3 columns per row */\n  gap: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.service-card {\n  background-color: none;\n  padding: 20px;\n  border-radius: 10px;\n  text-align: left; /* Left align content */\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n}\n\n.service-card:hover {\n  background-color: #1b7ff6;\n  color: white;\n}\n\n.service-card:hover .service-title,\n.service-card:hover .service-description {\n  color: white; \n}\n\n.service-icon {\n  width: 50px; /* Fixed width and height for the icon container */\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  background-color: #f0f0f0; /* Background color for the icon */\n  border-radius: 10px; /* Rounded corners around the icon */\n  margin-bottom: 15px;\n  border: 1px solid #ddd; /* Border around the icon */\n  color: #1b7ff6; /* Default icon color */\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.service-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.service-description {\n  font-size: 0.9rem;\n  color: #555;\n}\n\n/* Responsive Breakpoints */\n@media (max-width: 992px) {\n  .services-grid {\n    grid-template-columns: repeat(2, 1fr); /* 2 columns on medium screens */\n  }\n  .services-title {\n    font-size: 28px;\n  }\n  .services-container h3 {\n    font-size: 20px;\n  }\n  .services-container {\n    margin-top: 50px;\n  }\n}\n\n@media (max-width: 600px) {\n  .services-grid {\n    grid-template-columns: 1fr; /* 1 column on small screens */\n  }\n  .services-title {\n    font-size: 28px;\n  }\n  .services-container h3 {\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .services-title {\n    font-size: 28px;\n  }\n  .services-container h3 {\n    font-size: 20px;\n  }\n}\n\n/* Container layout */\n.approach-container {\n  width: 90%;\n  max-width: 1100px;\n  padding: 40px;\n  margin: 0 auto;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.approach-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.approach-header h2 {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #2c2c54;\n}\n\n.approach-header p {\n  font-size: 1.1rem;\n  color: #666;\n  margin: 0 auto;\n  margin-bottom: 20px;\n  max-width: 70%;\n}\n\n.tab-menu {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  margin-bottom: 20px;\n}\n\n.tab-item {\n  font-size: 1rem;\n  cursor: pointer;\n  color: #888;\n  padding-bottom: 5px;\n  border-bottom: 2px solid transparent;\n  transition: color 0.3s, border-color 0.3s;\n}\n\n.tab-item.active {\n  color: #1b7ff6;\n  border-bottom: 2px solid #1b7ff6;\n}\n\n/* Content Section */\n.approach-content {\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n  min-height: 400px;\n}\n\n.content-left {\n  width: 60%;\n  background-color: white;\n  padding: 30px;\n  border-radius: 8px;\n  text-align: left;\n  position: relative; /* Allows the button to be absolutely positioned */\n  min-height: 400px;\n}\n\n.content-left small {\n  text-align: left;\n  color: #1b7ff6;\n  margin-bottom: 10px;\n}\n\n.content-left h4 {\n  font-size: 1.2rem;\n  color: black;\n  margin-bottom: 20px;\n}\n\n.content-left p {\n  font-size: 1rem;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n/* Fixed CTA Button at the bottom-left */\n.cta-button {\n  position: absolute;\n  bottom: 20px;\n  left: 30px;\n  display: inline-block;\n  background-color: #1b7ff6;\n  color: white;\n  padding: 12px 25px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: bold;\n  text-align: center;\n}\n\n.cta-button:hover {\n  background-color: #004bbf;\n}\n\n/* Right Section: Image */\n.content-right {\n  width: 35%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.content-right img {\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 10px;\n}\n\n/* Cost Component */\n.table-container {\n  width: 85%;\n  max-width: 1000px;\n  margin: 0 auto;\n  margin-top: 80px;\n  margin-bottom: 80px;\n}\n\n.table-container h1 {\n  text-align: center;\n}\n\n.table-container h3 {\n  text-align: center;\n  color: #666;\n}\n\n.table-container a {\n  color: #1b7ff6;\n}\n\n.styled-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-size: 14px;\n  margin-top: 40px;\n}\n\n.styled-table th,\n.styled-table td {\n  padding: 12px 25px;\n  border: 1px solid #dddddd;\n  font-weight: 600;\n  min-height: 60 px; /* Set minimum height for rows */\n}\n\n.styled-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n  font-size: 20px;\n  text-align: center;\n}\n\n.table-logo {\n  width: 45%;\n}\n\n.table-border {\n  height: 100%;\n  width: 30%;\n  border: 1px solid #1b7ff6;\n}\n\n.styled-table td.right-column, \n.styled-table td.middle-column {\n  text-align: center !important;\n  width: 33%;\n}\n\n.styled-table td.middle-column {\n  border-left: 3px solid #1b7ff6;\n  border-right: 3px solid #1b7ff6;\n}\n\n.styled-table td.middle-column a {\n  cursor: pointer;\n  text-decoration: none;\n  color: black;\n  transition: transform 0.3s ease;\n}\n\n.styled-table th.middle-heading {\n  border-top: 3px solid #1b7ff6;\n  border-left: 3px solid #1b7ff6;\n  border-right: 3px solid #1b7ff6;\n}\n\n.styled-table tr:last-child td.middle-column {\n  border-bottom: 3px solid #1b7ff6;\n}\n\n.odd-row {\n  background-color: #f2f2f2;\n}\n\n.even-row {\n  background-color: #ffffff;\n}\n\n.toggle-container {\n  text-align: right;\n  margin-top: 20px;\n}\n\n.toggle-button {\n  padding: 10px 20px;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: transparent;\n  color: black;\n  border: none;\n  transition: background-color 0.5s ease-in-out;\n  font-weight: 600;\n}\n\n.toggle-button:hover {\n  text-decoration: underline;\n  color: #1b7ff6;\n}\n\n.styled-table tbody tr {\n  height: 60px; /* Set a fixed height for body rows */\n}\n\n/* Adjust the table for mobile screens */\n@media (max-width: 768px) {\n  /* Reduce container padding and margins */\n  .table-container {\n    width: 95%; /* Use more screen width */\n    margin: 50px auto; /* Smaller top and bottom margin */\n  }\n\n  /* Resize headings */\n  .table-container h1 {\n    font-size: 20px; /* Smaller font size */\n  }\n\n  .cost-heading {\n    font-size: 28px !important;\n  }\n\n  .table-container h3 {\n    font-size: 14px; /* Smaller font size */\n    line-height: 1.4; /* Adjust line height for better readability */\n  }\n\n  .cost-subheading {\n    font-size: 18px !important;\n  }\n\n\n  /* Adjust table font sizes and padding */\n  .styled-table {\n    font-size: 12px; /* Smaller text for the table */\n  }\n\n  .styled-table th, \n  .styled-table td {\n    padding: 8px 15px; /* Reduce cell padding */\n    font-size: 10px;\n  }\n\n  /* Reduce logo size */\n  .table-logo {\n    width: 50%; /* Smaller width for the logo */\n  }\n\n  /* Middle column adjustments */\n  .styled-table td.middle-column {\n    border-left: 3px solid #1b7ff6; /* Thinner border */\n    border-right: 3px solid #1b7ff6; /* Thinner border */\n  }\n\n  /* Adjust the toggle button */\n  .toggle-container {\n    text-align: center; /* Center the button on mobile */\n  }\n\n  .toggle-button {\n    font-size: 14px; /* Smaller font size for the button */\n    padding: 8px 15px; /* Reduce button padding */\n  }\n}\n\n/* Owner */\n.owner-section {\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  margin-top: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.owner-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  gap: 20px; /* Adds spacing between image and content */\n}\n\n.owner-image, .owner-content {\n  width: 50%; /* Ensures both image and content occupy equal width */\n  box-sizing: border-box;\n}\n\n.owner-image img {\n  width: 90%; /* Ensures the image fills its container */\n  height: auto;\n  padding: 10px;\n}\n\n.owner-content {\n  padding: 40px;\n  max-width: 100%; /* Remove the max-width to avoid restricting content width */\n  box-sizing: border-box;\n}\n\n.owner-content h2 {\n  font-size: 30px;\n  margin-bottom: 1rem;\n}\n\n.owner-content p {\n  font-size: 1rem;\n  width: 70%;\n  margin-bottom: 1.5rem;\n}\n\n.owner-button-space button {\n  background-color: #1b7ff6;\n  color: white;\n  padding: 15px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 16px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.owner-button-space button:hover {\n  transform: scale(1.1);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .owner-section {\n    margin-top: 0px;\n  }\n\n  .owner-container {\n    display: flex;\n    flex-direction: column; /* Stack content vertically */\n    align-items: center; /* Center-align all content horizontally */\n    justify-content: center; /* Center-align vertically */\n    padding: 20px; /* Adjust padding */\n    margin: 0 auto; /* Center the section */\n    margin-top: 0px;\n    width: 100%; /* Ensure full width */\n    max-width: 100%; /* Prevent overflow */\n    box-sizing: border-box; /* Include padding and border in width */\n    text-align: center; /* Center-align text */\n    overflow-x: hidden; /* Prevent horizontal scrolling */\n  }\n\n  .owner-image {\n    width: 80%; /* Take full width on smaller screens */\n  }\n\n  .owner-content {\n    text-align: center; /* Center align text on mobile */\n    padding: 10px; /* Adjust padding for smaller screens */\n    width: 70%;\n  }\n\n  .owner-content h2 {\n    font-size: 24px; /* Adjust font size */\n  }\n\n  .owner-content p {\n    font-size: 14px; /* Adjust font size */\n    width: 100%; /* Full width for text */\n  }\n\n  .owner-button-space button {\n    width: 100%; /* Full width button for mobile */\n  }\n}\n\n\n/* Location */\n\n.location-wrapper {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px;\n}\n\n.location-wrapper h1 {\n  text-align: center;\n  margin-bottom: 40px;\n} \n\n.location-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 15px;\n}\n\n.location-box {\n  border: 1px solid black;\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  cursor: pointer;\n  width: 150px;\n  height: 200px;\n  position: relative; /* For positioning child elements */\n  display: flex;\n  justify-content: center; /* Centers the image horizontally */\n  align-items: center; /* Centers the image vertically */\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.location-image {\n  width: 65%;\n  height: auto;\n  object-fit: cover;\n}\n\n.location-box p {\n  position: absolute; /* Position paragraph at the bottom */\n  bottom: 10px; /* Adjust spacing from the bottom */\n  left: 0;\n  right: 0;\n  margin: 0;\n  text-align: center;\n  font-size: 20px; /* Adjust font size if needed */\n  color: #333; /* Example color */\n}\n\n.location-box:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-color: #1b7ff6;\n}\n\n@media (max-width: 768px) {\n  .location-wrapper {\n    padding: 10px;\n    margin-top: 50px;\n  }\n\n  .location-box {\n    padding: 15px;\n    width: 100px;\n    height: 133px;\n  }\n\n  .location-image {\n    width: 60%; /* Adjust image size for smaller screens */\n  }\n\n  .location-box p {\n    font-size: 14px; /* Adjust font size for smaller screens */\n  }\n}\n\n/* src/components/ThankYou.css */\n.thank-you-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 300px;\n  background-color: none;\n  padding: 20px;\n}\n\n.thank-you-container p {\n  max-width: 550px;\n}\n\n.icon-container img {\n  width: 300px;\n  margin-bottom: 20px;\n  padding: 20px;\n}\n\n/*How it works*/\n.how-it-works-container {\n  text-align: center;\n  margin-top: 100px;\n  margin-bottom: 100px;\n}\n\n.how-it-works-subtitle {\n  color: #666;\n}\n\n.how-it-works-subtitle a{\n  color: #1b7ff6;\n}\n\n.how-it-works-carousel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px auto;\n  position: relative;\n  overflow: hidden;\n  max-width: 600px;\n}\n\n.how-it-works-nav {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n}\n\n.how-it-works-nav:hover {\n  color: #1b7ff6;\n  transform: scale(1.2);\n}\n\n.how-it-works-nav.disabled {\n  cursor: not-allowed;\n  opacity: 0;\n  pointer-events: none; /* Prevent any interaction */\n\n}\n\n.how-it-works-step-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 600px;\n  transition: transform 0.5s ease, opacity 0.5s ease;\n  opacity: 1;\n}\n\n.how-it-works-text {\n  font-size: 1.5rem;\n  color: #333;\n  max-width: 100%;\n  text-align: center;\n  height: 100px; /* Set a fixed height for all steps */\n  display: flex; /* Center align text vertically */\n  align-items: center;\n  justify-content: center;\n}\n\n.how-it-works-step-content.animate {\n  animation: slideIn 0.5s forwards ease;\n}\n\n@keyframes slideIn {\n  0% {\n    opacity: 0;\n    transform: translateX(20%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.how-it-works-image {\n  width: 70%;\n  margin-bottom: 15px;\n}\n\n.how-it-works-text {\n  font-size: 1.5rem;\n  color: #333;\n  max-width: 100%;\n}\n\n.how-it-works-indicators {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.how-it-works-indicator {\n  height: 30px;\n  width: 30px;\n  background-color: #ddd;\n  color: #333;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 5px;\n  cursor: pointer;\n  font-size: 1rem; \n  font-weight: bold;\n}\n\n.how-it-works-indicator.active {\n  background-color: #1b7ff6;\n  color: #fff;\n}\n\n@media (max-width: 768px) {\n  .how-it-works-container {\n    text-align: center;\n    margin-top: 50px;\n    margin-bottom: 100px;\n    padding: 10px;\n  }\n\n  .how-it-works-title {\n    font-size: 28px;\n  }\n\n  .how-it-works-subtitle {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n\n  .how-it-works-text {\n    font-size: 1.2rem; /* Smaller text for mobile */\n    height: 80px; /* Adjust height for smaller screens */\n    }\n\n}\n\n\n/* Kontakt */\n.contact {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  margin: 0 auto;\n  max-width: 950px;\n  width: 100%;\n}\n\n.contact-content {\n  position: relative;\n  height: auto;\n  text-align: left;\n  padding: 20px;\n  max-width: 50%;\n}\n\n\n.contact-paragraph {\n  width: 85%;\n}\n\n@media (max-width: 768px) {\n  .contact {\n    display: flex;\n    flex-direction: column; /* Stack content vertically */\n    justify-content: center; /* Center items vertically */\n    align-items: center; /* Center items horizontally */\n    padding: 0;\n    margin: 0 auto;\n    width: 100%; /* Full width for the container */\n    overflow: hidden; /* Prevent content overflow */\n  }\n\n  .contact-content {\n    max-width: 100%;\n  }\n\n  .contact-heading {\n    font-size: 28px;\n    text-align: center;\n  }\n  .contact-paragraph {\n    font-size: 16px;\n    text-align: center;\n    margin: 0 auto;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
